import HTTP from '../http-common';
import axios from 'axios';
import config from '../config/env';
let apiBaseUrl = config.VUE_APP_API_URL;
export default {
  /*
  * Auth
  */
  login(params) {
    return axios.post(apiBaseUrl + `login`, params)
  },
  logout() {
    return HTTP.get(apiBaseUrl + `logout`)
  },
  forgotPassword(params) {
    return axios.post(apiBaseUrl + `forgot-password`, params)
  },
  changePassword(params) {
    return axios.post(apiBaseUrl + `change-password`, params)
  },
  getAuth() {
    return HTTP.get(apiBaseUrl + `get-user`)
  },
  /*
  * Organization
  */
  getOrganizations(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `organization?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getOrganizationDetails(params) {
    return HTTP.get(apiBaseUrl + `organization/` + params)
  },
  createOrganization(params) {
    return HTTP.post(apiBaseUrl + `organization`, params)
  },
  updateOrganization(serviceline_id, params) {
    return HTTP.put(apiBaseUrl + `organization/` + serviceline_id, params)
  },
  deleteOrganization(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `organization/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  restoreOrganization(params) {
    return HTTP.post(apiBaseUrl + `restore-organization`, params)
  },
  permanentOrganizationRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-organization`, params)
  },
  switchOrganization(site_id, params) {
    return HTTP.post(apiBaseUrl + `slogin/` + site_id, params)
  },
  /*
  * Agency
  */
  getAgencies(params, data = {}, sort = {}) {

    let url = apiBaseUrl + `agency?page=` + params.page + `&per_page=` + params.perPage;

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getActiveAgency(params) {
    return HTTP.get(apiBaseUrl + `agency-list`, params)
  },
  createAgency(params) {
    return HTTP.post(apiBaseUrl + `agency`, params)
  },
  deleteAgency(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `agency/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  getAgencyDetails(params) {
    return HTTP.get(apiBaseUrl + `agency/` + params)
  },
  updateAgency(agency_id, params) {
    return HTTP.post(apiBaseUrl + `agency-update/` + agency_id, params)
  },
  restoreAgency(params) {
    return HTTP.post(apiBaseUrl + `restore-agency`, params)
  },
  permanentAgencyRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-agency`, params)
  },
  getDeleteAgency(params, data = {}, sort = {}) {

    let url = apiBaseUrl + `deleted-agency?page=` + params.page + `&per_page=` + params.perPage;

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getAgencyLocations(params) {
    return HTTP.post(apiBaseUrl + `agencies/locations`, params)
  },

  /*
  * packages
  */
  getPackages(params) {
    return HTTP.get(apiBaseUrl + `packages`, params)
  },
  createPackage(params) {
    return HTTP.post(apiBaseUrl + `packages`, params)
  },
  deletePackage(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `packages/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  getPackageDetails(params) {
    return HTTP.get(apiBaseUrl + `packages/` + params)
  },
  updatePackage(agency_id, params) {
    return HTTP.put(apiBaseUrl + `packages/` + agency_id, params)
  },

  /*
  * service
  */
  getServices(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `services?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getServiceDetails(params) {
    return HTTP.get(apiBaseUrl + `services/` + params)
  },
  getServicesDetails(ids) {
    return HTTP.get(apiBaseUrl + `all-services?id=` + ids)
  },
  createService(params) {
    return HTTP.post(apiBaseUrl + `services`, params)
  },
  updateService(service_id, params) {
    return HTTP.put(apiBaseUrl + `services/` + service_id, params)
  },
  deleteService(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `services/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  restoreService(params) {
    return HTTP.post(apiBaseUrl + `restore-service`, params)
  },
  permanentServiceRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-service`, params)
  },
  getDeleteService(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `deleted-service?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  ExportServices() {
    // return HTTP.get(apiBaseUrl+`export-service`);
    return HTTP.post(apiBaseUrl + `export-service`);
  },
  // ImportServices(params){
  //   return HTTP.post(apiBaseUrl+`import-service`, params);
  // },
  getAllServices(params) {
    return HTTP.get(apiBaseUrl + `all-services?search=` + params)
  },
  /*
  * service line
  */
  getAllServiceLines(params) {
    return HTTP.get(apiBaseUrl + `all-service-lines?search=` + params)
  },
  getServiceLines(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `service-line?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getServiceLineDetails(params) {
    return HTTP.get(apiBaseUrl + `service-line/` + params)
  },
  createServiceLine(params) {
    return HTTP.post(apiBaseUrl + `service-line`, params)
  },
  updateServiceLine(serviceline_id, params) {
    return HTTP.put(apiBaseUrl + `service-line/` + serviceline_id, params)
  },
  deleteServiceLine(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `service-line/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  restoreServiceLine(params) {
    return HTTP.post(apiBaseUrl + `restore-service-line`, params)
  },
  permanentServiceLineRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-service-line`, params)
  },
  getDeleteServiceLines(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `deleted-service-line?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  ExportServiceLines() {
    return HTTP.post(apiBaseUrl + `export-service-line`);
  },
  // ImportServiceLines(params){
  //   return HTTP.post(apiBaseUrl+`import-service-line`, params);
  // },
  /*
  * Payer
  */
  getPayer(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `payers?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  createPayer(params) {
    return HTTP.post(apiBaseUrl + `payers`, params)
  },
  deletePayer(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `payers/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  updatePayer(payers_id, params) {
    return HTTP.put(apiBaseUrl + `payers/` + payers_id, params)
  },
  restorePayer(params) {
    return HTTP.post(apiBaseUrl + `restore-payers`, params)
  },
  permanentPayerRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-payers`, params)
  },
  getDeletePayer(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `deleted-payers?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getPayerDetails(payer_id) {
    return HTTP.get(apiBaseUrl + 'get-payer-datails/' + payer_id);
  },
  /*
  * Payer Case
  */
  getPayerCase(payer_id, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `payer/payer-cases/` + payer_id + `?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  createPayerCase(params) {
    return HTTP.post(apiBaseUrl + `payer-cases`, params)
  },
  deletePayerCase(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `payer-cases/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  getPayerCaseDetails(params) {
    return HTTP.get(apiBaseUrl + `payer-cases/` + params)
  },
  updatePayerCase(payer_cases_id, params) {
    return HTTP.put(apiBaseUrl + `payer-cases/` + payer_cases_id, params)
  },

  /*
  * Folder
  */
  getAllFolders(params) {
    return HTTP.get(apiBaseUrl + `folders-all`, params)
  },
  getFolders(params, data = {}, sort = {}) {
    // console.log(params);
    let url = apiBaseUrl + `folders?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(params) && params.student_id && params.student_id != '') {
      url += `&studentId=` + params.student_id;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  createFolder(params) {
    return HTTP.post(apiBaseUrl + `folders`, params)
  },
  // deleteFolder(params){
  //   let pathName = window.location.pathname.replace('/','');
  //   return HTTP.delete(apiBaseUrl+`folders/`+params+`?redirect_to=`+window.location.origin+`/delete-`+pathName)
  // },
  // getFolderDetails(params){
  //   return HTTP.get(apiBaseUrl+`folders/`+params)
  // },
  updateFolder(folder_id, params) {
    return HTTP.put(apiBaseUrl + `folders/` + folder_id, params)
  },
  getPfolders(params) {
    return HTTP.get(apiBaseUrl + `folder/parents`, params)
  },
  restoreFolder(params) {
    return HTTP.post(apiBaseUrl + `restore-folder`, params)
  },
  permanentFolderRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-folder`, params)
  },
  getDeletedFolders(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `deleted-folder?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },

  /*
  * Files
  */
  getFiles(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `files?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getPFiles(folder_id, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `filesByFolder/` + folder_id + `?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  createFile(params) {
    return HTTP.post(apiBaseUrl + `files`, params)
  },
  // deleteFile(params){
  //   let pathName = window.location.pathname.replace('/','');
  //   return HTTP.delete(apiBaseUrl+`files/`+params+`?redirect_to=`+window.location.origin+`/delete-`+pathName)
  // },
  // getFileDetails(params){
  //   return HTTP.get(apiBaseUrl+`files/`+params)
  // },
  updateFile(file_id, params) {
    return HTTP.post(apiBaseUrl + `files-update/` + file_id, params)
  },
  restoreFile(params) {
    return HTTP.post(apiBaseUrl + `restore-file`, params)
  },
  permanentFileRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-file`, params)
  },
  getDeletedFiles(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `deleted-file?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  /*
  * Students
  */
  getStudents(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `student?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&agency_name=` + data.agency_name + `&student_id=` + data.student_id + `&funder_name=` + data.funder_name + `&staff_name=` + data.staff_name + `&status=` + data.status + `&authorization_start_date=` + data.authorization_start_date + `&authorization_end_date=` + data.authorization_end_date + `&dob_month=` + data.dob_month + `&dob_year=` + data.dob_year + `&serviceLine=` + data.serviceLine + `&service=` + data.service + `&billingCode=` + data.billingCode;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getImportStudentCount() {
    return HTTP.get(apiBaseUrl + `student-check-import-status`);
  },
  downloadAllStudents(data = {}, sort = {}) {
    let payload = { ...data, ...sort }
    let url = apiBaseUrl + `export-student-all`;

    // if(!_.isEmpty(data)) {
    // url = url+`agency_name=`+data.agency_name+`&student_id=`+data.student_id+`&funder_name=`+data.funder_name+`&staff_name=`+data.staff_name+`&status=`+data.status+`&authorization_start_date=`+data.authorization_start_date+`&authorization_end_date=`+data.authorization_end_date+`&dob_month=`+data.dob_month+`&dob_year=`+data.dob_year+`&serviceLine=`+data.serviceLine+`&service=`+data.service+`&billingCode=`+data.billingCode;
    // url = url+`&agency_name=`+data.agency_name+`&student_name=`+data.student_name+`&funder_name=`+data.funder_name+`&staff_name=`+data.staff_name;
    // }

    // if(!_.isEmpty(sort)) {
    //   url = url+`&sort_by=`+sort.sort_by+`&sort_field_name=`+sort.sort_field_name;
    // }

    return HTTP.post(url, payload);
  },
  exportAuthData(data = {}) {
    let url = apiBaseUrl + `export-auth`;

    // if(!_.isEmpty(data)) {
    // url = url+`agency_name=`+data.agency_name+`&student_id=`+data.student_id+`&funder_name=`+data.funder_name+`&staff_name=`+data.staff_name+`&status=`+data.status+`&authorization_start_date=`+data.authorization_start_date+`&authorization_end_date=`+data.authorization_end_date+`&dob_month=`+data.dob_month+`&dob_year=`+data.dob_year+`&serviceLine=`+data.serviceLine+`&service=`+data.service+`&billingCode=`+data.billingCode;
    // url = url+`&agency_name=`+data.agency_name+`&student_name=`+data.student_name+`&funder_name=`+data.funder_name+`&staff_name=`+data.staff_name;
    // }

    // if(!_.isEmpty(sort)) {
    //   url = url+`&sort_by=`+sort.sort_by+`&sort_field_name=`+sort.sort_field_name;
    // }

    return HTTP.post(url, data);
  },
  studentFilters() {
    return HTTP.get(apiBaseUrl + `student-dropdown-filter`);
  },
  createStudent(params) {
    return HTTP.post(apiBaseUrl + `student`, params)
  },
  deleteStudent(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `student/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  getStudentDetails(params) {
    return HTTP.get(apiBaseUrl + `student/` + params)
  },
  updateStudent(student_id, params) {
    return HTTP.post(apiBaseUrl + `student-update/` + student_id, params)
  },
  restoreStudent(params) {
    return HTTP.post(apiBaseUrl + `restore-student`, params)
  },
  permanentStudentRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-student`, params)
  },
  getDeleteStudent(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `deleted-student?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&agency_name=` + data.agency_name + `&student_name=` + data.student_name + `&funder_name=` + data.funder_name + `&staff_name=` + data.staff_name;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  exportStudent(params) {
    return HTTP.post(apiBaseUrl + `export-student`, params);
  },
  getStudentAgency(student_id) {
    return HTTP.get(apiBaseUrl + `agency-student/` + student_id)
  },
  getstudentsByParent(user_id) {
    return HTTP.get(apiBaseUrl + `student-by-parent/` + user_id)
  },

  /*
  * Students Availability
  */
  getstudentAvailability(params) {
    return HTTP.get(apiBaseUrl + `student-availability/` + params);
  },
  createStudentAvailability(params) {
    return HTTP.post(apiBaseUrl + `student-availability`, params);
  },

  /*
  * Students File
  */
  getstudentFiles(params) {
    return HTTP.post(apiBaseUrl + `student-file/list`, params);
  },
  renamestudentFile(params) {
    return HTTP.post(apiBaseUrl + `student-file/rename-file`, params);
  },
  movestudentFile(params) {
    return HTTP.post(apiBaseUrl + `student-file/move-file`, params);
  },
  copystudentFile(params) {
    return HTTP.post(apiBaseUrl + `student-file/copy-file`, params);
  },
  deletestudentFile(params) {
    return HTTP.post(apiBaseUrl + `student-file/delete-file`, params);
  },
  getstudentUnassignFiles(params) {
    return HTTP.post(apiBaseUrl + `student-file/unassign-list`, params);
  },
  studentAssignFile(params) {
    return HTTP.post(apiBaseUrl + `student-file/assign`, params);
  },

  /*
  * Students staff
  */
  getStaffWithSearch(params, searchKey) {
    if (searchKey)
      return HTTP.get(apiBaseUrl + `user/type/` + params + '?search=' + searchKey);

    return HTTP.get(apiBaseUrl + `user/type/` + params);
  },

  addStudentStuff(params) {
    return HTTP.post(apiBaseUrl + `student-staff`, params);
  },

  editStudentStuff(params, id) {
    return HTTP.put(apiBaseUrl + `student-staff/` + id, params);
  },

  getStudentStuffById(param, search = "") {
    return HTTP.get(apiBaseUrl + `student/staff-list/` + param + `?search=` + search);
  },
  getStudentStuffunassignById(param, search = "") {
    return HTTP.get(apiBaseUrl + `student/staff-list-unassigned/` + param + `?search=` + search);
  },
  getStudentByStuffId(param, search = "") {
    return HTTP.get(apiBaseUrl + `staff/student-list/` + param + `?search=` + search);
  },

  deleteStudentStuffById(param) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `student-staff/` + param + `?redirect_to=` + window.location.origin + `/delete-` + pathName);
  },

  resendStudentStaffContract(student_staff_id) {
    return HTTP.post(apiBaseUrl + `student-staff/${student_staff_id}/resend-contract`);
  },

  getUnassignedUsers(param) {
    return HTTP.get(apiBaseUrl + `student/unassigned-staff-list/` + param);
  },

  getStaffSchools(id) {
    return HTTP.get(apiBaseUrl + `user-school/` + id);
  },

  addSchoolsToStaff(params) {
    return HTTP.post(apiBaseUrl + `user-schools`, params);
  },

  /*
  * Proptech
  */
  syncStaff(userId) {
    let url = apiBaseUrl + `payroll/persons`;
    return HTTP.post(url, { user_id: userId });
  },

  deleteStaff(userId) {
    let url = apiBaseUrl + `payroll/persons`;
    return HTTP.delete(url, {
      data: { user_id: userId }
    });
  },

  syncAllStaff(sessionId = null) {
    let url = apiBaseUrl + `payroll/persons/sync-all`;

    const headers = {};
    if (sessionId) {
      headers['X-Session-ID'] = sessionId;
    }
    return HTTP.post(url, {}, { headers });
  },

  getSyncProgress(sessionId) {
    let url = apiBaseUrl + `payroll/persons/sync-progress`;
    const headers = {};
    if (sessionId) {
      headers['X-Session-ID'] = sessionId;
    }

    return HTTP.get(url, {
      headers,
      params: { session_id: sessionId }
    });
  },

  getStaffStatus(userId) {
    let url = apiBaseUrl + `payroll/person-status`;
    return HTTP.get(url + `/` + userId);
  },

  getBulkStaffStatus(userIds) {
    let url = apiBaseUrl + `payroll/persons/bulk-status`;
    return HTTP.post(url, { user_ids: userIds });
  },

  getPunchHistory(userId) {
    let url = apiBaseUrl + `payroll/persons`
    return HTTP.get(url + `/` + userId);
  },

  /*
  * Students Settings
  */
  getStudentsettingsById(param) {
    return HTTP.post(apiBaseUrl + `student-settings-list`, param);
  },

  saveStudentSettings(param) {
    return HTTP.post(apiBaseUrl + `student-settings`, param);
  },

  /*
  * Goals
  */
  getGoals(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `goals?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getMassGoalDropdown() {
    return HTTP.get(apiBaseUrl + `mass-goal-dropdown-filter`)
  },
  getMassImportStatus() {
    return HTTP.get(apiBaseUrl + `goal-import/check-import-status`)
  },
  getParentGoals(params) {
    return HTTP.get(apiBaseUrl + `parent-goals`, params)
  },
  getChildGoals(params) {
    return HTTP.get(apiBaseUrl + `sub-goals/` + params)
  },
  deleteGoal(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `goals/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  createGoal(params) {
    return HTTP.post(apiBaseUrl + `goals`, params);
  },
  updateGoal(goal_id, params) {
    return HTTP.put(apiBaseUrl + `goals/` + goal_id, params)
  },
  getGoalDetails(params) {
    return HTTP.get(apiBaseUrl + `goals/` + params)
  },
  restoreGoal(params) {
    return HTTP.post(apiBaseUrl + `restore-goals`, params)
  },
  permanentGoalRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-goals`, params)
  },
  getDeleteGoal() {
    return HTTP.get(apiBaseUrl + `deleted-goals`);
  },

  massGoalDataImport(params) {
    return HTTP.post(apiBaseUrl + `mass-goal-data-import`, params);
  },
  getGoalImportDataList(params, data = {}, sort = {}) {

    let url = apiBaseUrl + `get-goal-import-list?page=` + params.page + `&per_page=` + params.perPage;

    if (!_.isEmpty(data)) {
      url = url + `&start_date=` + data.start_date + `&end_date=` + data.end_date + `&skill_area=` + data.skill_area + `&student_name=` + data.student_name + `&target_name=` + data.target_name;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getGoalImportDataListAll(data = {}) {

    let url = apiBaseUrl + `get-goal-import-list-all?`;

    if (!_.isEmpty(data)) {
      url = url + `start_date=` + data.start_date + `&end_date=` + data.end_date + `&skill_area=` + data.skill_area + `&student_name=` + data.student_name + `&target_name=` + data.target_name + `&recordingType=` + data.recordingType;
    }

    return HTTP.get(url);
  },
  getMassGoalImportedData(data = {}) {
    let url = apiBaseUrl + `mass-goal-data-export`;

    // if(!_.isEmpty(data)) {
    //   url = url+`&start_date=`+data.start_date+`&end_date=`+data.end_date+`&skill_area=`+data.skill_area+`&student_name=`+data.student_name+`&target_name=`+data.target_name+`&send_email=`+data.send_email;
    // }

    return HTTP.post(url, data);
  },
  filterGoalImportData(params) {
    return HTTP.post(apiBaseUrl + `filter-goal-import-list`, params);
  },

  /*
  * Hcode
  */
  getBillingcodes(params) {
    return HTTP.get(apiBaseUrl + `billing-codes`, params);
  },
  getBillingcodelDetails(params) {
    return HTTP.get(apiBaseUrl + `billing-codes/` + params)
  },
  createBillingcode(params) {
    return HTTP.post(apiBaseUrl + `billing-codes`, params);
  },
  updateBillingcode(billingcode_id, params) {
    return HTTP.put(apiBaseUrl + `billing-codes/` + billingcode_id, params)
  },
  deleteBillingcode(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `billing-codes/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  restoreBillingcode(params) {
    return HTTP.post(apiBaseUrl + `restore-billing-codes`, params)
  },
  permanentBillingcodeRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-billing-codes`, params)
  },
  getDeleteBillingcode() {
    return HTTP.get(apiBaseUrl + `deleted-billing-codes`);
  },
  ExportBillingcode() {
    return HTTP.post(apiBaseUrl + `export-billing-codes`);
  },
  ImportBillingcode(params) {
    return HTTP.post(apiBaseUrl + `import-billing-codes`, params);
  },
  /*
  * User
  */
  getUsers(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `users?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search + `&serviceLine=` + data.serviceLine + `&funder=` + data.funder + `&status=` + data.status + `&title=` + data.title;

      // External sync filters
      if (data.proptech_status !== undefined && data.proptech_status !== null && data.proptech_status !== '') {
        url = url + `&proptech_status=` + data.proptech_status;
      }

      if (data.viventium_status !== undefined && data.viventium_status !== null && data.viventium_status !== '') {
        url = url + `&viventium_status=` + data.viventium_status;
      }
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getUsersWithContactsForDropdown(search = '') {
    // ?sort_field_name&sort_by&per_page&search
    let url = apiBaseUrl + `all-student-with-contact`;

    if (search != '') {
      url += '?search=' + search
    }
    return HTTP.get(url);
  },

  getImportUserCount() {
    return HTTP.get(apiBaseUrl + `staff-import/check-import-status`);
  },
  getExportUsers() {
    return HTTP.post(apiBaseUrl + `staff-export`);
  },
  createUser(params) {
    return HTTP.post(apiBaseUrl + `users`, params)
  },
  deleteUser(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `users/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  getUserDetails(params) {
    return HTTP.get(apiBaseUrl + `users/` + params)
  },
  updateUser(user_id, params) {
    return HTTP.post(apiBaseUrl + `user-update/` + user_id, params)
  },
  getUsersByType(userType, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `user/type/` + userType + `?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getGoalImportData(params) {
    let url = apiBaseUrl + `student-program?page=` + params.page + `&per_page=` + params.perPage;

    if (params.student_id !== undefined && params.student_id !== null) {
      url = url + `&student_id=` + params.student_id;
    }

    if (params.search !== undefined && params.search !== null) {
      url = url + `&search=` + params.search;
    }

    if (params.cat_id !== undefined && params.cat_id !== null) {
      url = url + `&cat_id=` + params.cat_id;
    }

    return HTTP.get(url);
  },
  updateGoalData(goal_id, params) {
    let url = apiBaseUrl + `student-program/${goal_id}`;
    return HTTP.put(url, params);
  },
  deleteGoalData(goal_id) {
    let url = apiBaseUrl + `student-program/${goal_id}`;
    return HTTP.delete(url);
  },
  getUserSignature(user_id) {
    return HTTP.get(apiBaseUrl + `user/signature/` + user_id)
  },
  updateUserSignature(user_id, params) {
    return HTTP.post(apiBaseUrl + `user/siganture/update/` + user_id, params)
  },
  restoreUser(params) {
    return HTTP.post(apiBaseUrl + `restore-user`, params)
  },
  permanentUserRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-user`, params)
  },
  getDeleteUser(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `deleted-user?user_type=parent`;

    if (!_.isEmpty(params)) {
      url = url + `&page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },

  getDeleteUserStaff(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `deleted-user`;

    if (!_.isEmpty(params)) {
      url = url + `?page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },

  // user documents

  getUserDocuments(staff_id) {
    let url = apiBaseUrl + `staff-file/${staff_id}`;
    return HTTP.get(url);
  },

  uploadUserDocuments(params) {
    let url = apiBaseUrl + `staff-file`;
    return HTTP.post(url, params);
  },

  updateUserDocuments(id, params) {
    let url = apiBaseUrl + `staff-file/${id}`;
    return HTTP.put(url, params);
  },

  deleteUserDocument(id) {
    return HTTP.delete(apiBaseUrl + `staff-file/${id}`);
  },

  downloadAllDocuments(staff_id) {
    let url = apiBaseUrl + `staff-download-files?staff_id=${staff_id}`
    return HTTP.get(url);
  },

  getStaffDocumentNotification() {
    let url = apiBaseUrl + `staff-file-notification`;
    return HTTP.get(url);
  },

  exportUserDocuments() {
    let url = apiBaseUrl + `export-staff-file`;
    return HTTP.post(url);
  },

  createUserAvailability(params) {
    return HTTP.post(apiBaseUrl + `user-availability`, params);
  },
  getUserAvailability(params) {
    return HTTP.get(apiBaseUrl + `user-availability/` + params);
  },
  checkUserAvailability(params) {
    return HTTP.post(apiBaseUrl + `user/check-availability`, params);
  },
  getAllUsers(search) {
    return HTTP.get(apiBaseUrl + `all-users?search=` + search);
  },
  getBCBASignature(user_id) {
    return HTTP.get(apiBaseUrl + `bcba-signature/` + user_id)
  },
  updateGuestUserSignature(params) {
    return HTTP.post(apiBaseUrl + `guest-bcba-signature`, params)
  },
  getStaffByService(service_id) {
    return HTTP.get(apiBaseUrl + `staff-by-service/` + service_id)
  },
  getSessionEnteringPersons() {
    return HTTP.get(apiBaseUrl + `session-entering-person`)
  },
  /*
  * Diagnosis
  */
  getDiagnosis(params) {
    return HTTP.get(apiBaseUrl + `diagnosis`, params)
  },
  createDiagnosis(params) {
    return HTTP.post(apiBaseUrl + `diagnosis`, params)
  },
  deleteDiagnosis(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `users/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  getDiagnosisDetails(params) {
    return HTTP.get(apiBaseUrl + `diagnosis/` + params)
  },
  updateDiagnosis(diagnosis_id, params) {
    return HTTP.put(apiBaseUrl + `diagnosis/` + diagnosis_id, params)
  },
  restoreDiagnosis(params) {
    return HTTP.post(apiBaseUrl + `restore-diagnosis`, params)
  },
  permanentDiagnosisRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-diagnosis`, params)
  },
  getDeleteDiagnosis() {
    return HTTP.get(apiBaseUrl + `deleted-diagnosis`);
  },
  getDiagnosisByType(type) {
    return HTTP.get(apiBaseUrl + `diagnosis/type/` + type);
  },
  ExportDiagnosis() {
    return HTTP.post(apiBaseUrl + `export-diagnosis`);
  },
  ImportDiagnosis(params) {
    return HTTP.post(apiBaseUrl + `import-diagnosis`, params);
  },
  /*
  * Program Library
  */
  getPrograms(params) {
    return HTTP.get(apiBaseUrl + `program`, params)
  },
  createProgram(params) {
    return HTTP.post(apiBaseUrl + `program`, params)
  },
  deleteProgram(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `program/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  getProgramDetails(params) {
    return HTTP.get(apiBaseUrl + `program/` + params)
  },
  updateProgram(program_id, params) {
    return HTTP.post(apiBaseUrl + `program-update/` + program_id, params)
  },
  getProgramCat(params) {
    return HTTP.get(apiBaseUrl + `parent-goals`, params)
  },
  getProgramSubCat(params) {
    return HTTP.get(apiBaseUrl + `sub-goals/` + params)
  },
  restoreProgram(params) {
    return HTTP.post(apiBaseUrl + `restore-program`, params)
  },
  permanentProgramRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-program`, params)
  },
  getDeleteProgram() {
    return HTTP.get(apiBaseUrl + `deleted-program`);
  },
  ExportProgram() {
    return HTTP.post(apiBaseUrl + `export-program`);
  },
  ImportProgram(params) {
    return HTTP.post(apiBaseUrl + `import-program`, params);
  },
  /*
  * Assessment Category
  */
  getAssessmentCat(params) {
    return HTTP.get(apiBaseUrl + `assessment-category`, params)
  },
  getParentAssessmentCat(params) {
    return HTTP.get(apiBaseUrl + `assessment/parent-category`, params)
  },
  getChildAssessmentCat(params) {
    return HTTP.get(apiBaseUrl + `assessment/category/sub-cat/` + params)
  },
  deleteAssessmentCat(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `assessment-category/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  createAssessmentCat(params) {
    return HTTP.post(apiBaseUrl + `assessment-category`, params);
  },
  updateAssessmentCat(cat_id, params) {
    return HTTP.put(apiBaseUrl + `assessment-category/` + cat_id, params)
  },
  getAssessmentCatDetails(params) {
    return HTTP.get(apiBaseUrl + `assessment-category/` + params)
  },
  restoreAssessmentCat(params) {
    return HTTP.post(apiBaseUrl + `restore-assessment-category`, params)
  },
  permanentAssessmentCatRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-assessment-category`, params)
  },
  getDeleteAssessmentCat() {
    return HTTP.get(apiBaseUrl + `deleted-assessment-category`);
  },

  /*
  * Assessment
  */
  getAssessment(params) {
    return HTTP.get(apiBaseUrl + `assessments`, params)
  },
  getAssessmentDetails(params) {
    return HTTP.get(apiBaseUrl + `assessments/` + params)
  },
  deleteAssessment(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `assessments/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  createAssessment(params) {
    return HTTP.post(apiBaseUrl + `assessments`, params);
  },
  updateAssessment(assessment_id, params) {
    return HTTP.put(apiBaseUrl + `assessments/` + assessment_id, params)
  },
  restoreAssessment(params) {
    return HTTP.post(apiBaseUrl + `restore-assessments`, params)
  },
  permanentAssessmentRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-assessments`, params)
  },
  getDeleteAssessment() {
    return HTTP.get(apiBaseUrl + `deleted-assessments`);
  },

  /*
  * States
  */
  getStates(params) {
    return HTTP.get(apiBaseUrl + `get-states`, params)
  },

  /*
  * Payer Service Line
  */
  getPayerServiceLine(payer_id, params) {
    return HTTP.get(apiBaseUrl + `payer/serviceline/` + payer_id, params)
  },
  getPayerServiceLineDetails(params) {
    return HTTP.get(apiBaseUrl + `payer/service-line/` + params)
  },
  deletePayerServiceLine(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `payer/service-line/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  createPayerServiceLine(params) {
    return HTTP.post(apiBaseUrl + `payer/service-line`, params);
  },
  updatePayerServiceLine(service_line_id, params) {
    return HTTP.put(apiBaseUrl + `payer/service-line/` + service_line_id, params)
  },
  getPayerByServiceLine(service_line_id, params) {
    return HTTP.get(apiBaseUrl + `service-line-payers/` + service_line_id, params)
  },
  getPayerByServiceLineForSelect(service_line_id) {
    return HTTP.get(apiBaseUrl + `service-line-payers/` + service_line_id)
  },
  getUnassignPayerServiceLine(payer_id) {
    return HTTP.get(apiBaseUrl + `payer/unassign-serviceline/` + payer_id)
  },

  /*
  * Payer Billing Code
  */
  getPayerBillingCode(payer_id, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `payer/billingcode/` + payer_id + '?';

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getPayerBillingCodeDetails(params) {
    return HTTP.get(apiBaseUrl + `payer/billing-code/` + params)
  },
  deletePayerBillingCode(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `payer/billing-code/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  createPayerBillingCode(params) {
    return HTTP.post(apiBaseUrl + `payer/billing-code`, params);
  },
  updatePayerBillingCode(billing_code_id, params) {
    return HTTP.put(apiBaseUrl + `payer/billing-code/` + billing_code_id, params)
  },
  getUnassignPayerBillingCodeServiceLine(payer_id, id = 0) {
    return HTTP.get(apiBaseUrl + `payer/billingcode/unassign-serviceline/` + payer_id + '/' + id)
  },
  getFunderBillingDetails(payer_id, agency_id, service_id) {
    return HTTP.get(apiBaseUrl + `payer/billingcode/service/details/` + payer_id + '/' + agency_id + '/' + service_id);
  },

  /*
  * Certificate
  */
  getCertification(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `certifications?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getCertificationDetails(params) {
    return HTTP.get(apiBaseUrl + `certifications/` + params)
  },
  deleteCertification(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `certifications/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  createCertification(params) {
    return HTTP.post(apiBaseUrl + `certifications`, params);
  },
  updateCertification(cid, params) {
    return HTTP.put(apiBaseUrl + `certifications/` + cid, params)
  },
  restoreCertification(params) {
    return HTTP.post(apiBaseUrl + `restore-certifications`, params)
  },
  permanentCertificationRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-certifications`, params)
  },
  getDeleteCertifications(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `deleted-certifications?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  ExportCertifications() {
    return HTTP.post(apiBaseUrl + `export-certifications`);
  },
  ImportCertifications(params) {
    return HTTP.post(apiBaseUrl + `import-certifications`, params);
  },

  /*
  * TimeZone
  */
  getTimeZone(params) {
    return HTTP.get(apiBaseUrl + `timezone`, params)
  },

  /*
  * User Service Line
  */
  getUserServiceLine(user_id, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `user-service-line/` + user_id + '?';

    if (!_.isEmpty(params)) {
      url = url + `&page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getUserServiceLineDetails(params) {
    return HTTP.get(apiBaseUrl + `user/service-line/` + params)
  },
  deleteUserServiceLine(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `user/service-line/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  createUserServiceLine(params) {
    return HTTP.post(apiBaseUrl + `user/service-line`, params);
  },
  updateUserServiceLine(service_line_id, params) {
    return HTTP.put(apiBaseUrl + `user/service-line/` + service_line_id, params)
  },

  /* Stage Status Master */
  getStageStatusMaster(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `stage-status-master?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getStageStatusMasterDetails(params) {
    return HTTP.get(apiBaseUrl + `stage-status-master/` + params)
  },
  deleteStageStatusMaster(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `stage-status-master/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  createStageStatusMaster(params) {
    return HTTP.post(apiBaseUrl + `stage-status-master`, params);
  },
  updateStageStatusMaster(cid, params) {
    return HTTP.put(apiBaseUrl + `stage-status-master/` + cid, params)
  },
  restoreStageStatusMaster(params) {
    return HTTP.post(apiBaseUrl + `restore-stage-status-master`, params)
  },
  permanentStageStatusMasterRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-stage-status-master`, params)
  },
  getDeleteStageStatusMaster(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `deleted-stage-status-master?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },

  /* Check List Master */
  getCheckListMaster(params) {
    return HTTP.get(apiBaseUrl + `checklist-master`, params)
  },
  getCheckListMasterDetails(params) {
    return HTTP.get(apiBaseUrl + `checklist-master/` + params)
  },
  deleteCheckListMaster(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `checklist-master/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  createCheckListMaster(params) {
    return HTTP.post(apiBaseUrl + `checklist-master`, params);
  },
  updateCheckListMaster(cid, params) {
    return HTTP.put(apiBaseUrl + `checklist-master/` + cid, params)
  },
  restoreCheckListMaster(params) {
    return HTTP.post(apiBaseUrl + `restore-checklist-master`, params)
  },
  permanentCheckListMasterRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-checklist-master`, params)
  },
  getDeleteCheckListMaster() {
    return HTTP.get(apiBaseUrl + `deleted-checklist-master`);
  },

  /* Dynamic Field */
  getAllDynamicField(params) {
    return HTTP.get(apiBaseUrl + `all-dynamic-field`, params)
  },
  getDynamicField(params) {
    return HTTP.get(apiBaseUrl + `dynamic-field`, params)
  },
  getDynamicFieldDetails(params) {
    return HTTP.get(apiBaseUrl + `dynamic-field/` + params)
  },
  deleteDynamicField(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `dynamic-field/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  createDynamicField(params) {
    return HTTP.post(apiBaseUrl + `dynamic-field`, params);
  },
  updateDynamicField(cid, params) {
    return HTTP.put(apiBaseUrl + `dynamic-field/` + cid, params)
  },
  restoreDynamicField(params) {
    return HTTP.post(apiBaseUrl + `restore-dynamic-field`, params)
  },
  permanentDynamicFieldRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-dynamic-field`, params)
  },
  getDeleteDynamicField() {
    return HTTP.get(apiBaseUrl + `deleted-dynamic-field`);
  },

  /* Roles */
  getRole(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `role-permission?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getRoleDetails(params) {
    return HTTP.get(apiBaseUrl + `role/` + params)
  },
  // deleteRole(params) {
  //   let pathName = window.location.pathname.replace('/','');
  //   return HTTP.delete(apiBaseUrl+`role/`+params+`?redirect_to=`+window.location.origin+`/delete-`+pathName)
  // },
  deleteRole(id) {
    // let pathName = window.location.pathname.replace('/','');
    return HTTP.delete(apiBaseUrl + `role-permission/${id}`)
  },
  createRole(params) {
    return HTTP.post(apiBaseUrl + `role`, params);
  },
  updateRole(role_id, params) {
    return HTTP.put(apiBaseUrl + `role/` + role_id, params)
  },

  /* Permission */
  getPermission(params) {
    return HTTP.get(apiBaseUrl + `permission`, params)
  },

  getPermissionDetails(id) {
    return HTTP.get(apiBaseUrl + `role-permission/${id}/edit`)
  },

  getAllPermissions() {
    return HTTP.get(apiBaseUrl + `role-permission/create`)
  },

  createPermissionRole(params) {
    return HTTP.post(apiBaseUrl + `role-permission`, params);
  },

  updatePermissionRole(params, id) {
    console.log('params', params)
    return HTTP.post(apiBaseUrl + `role-permission/${id}`, params);
  },

  /* User Group */
  getUserGroup(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `user-group?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getUserGroupDetails(params) {
    return HTTP.get(apiBaseUrl + `user-group/` + params)
  },
  getAllRoles() {
    return HTTP.get(apiBaseUrl + `all-roles`)
  },
  deleteUserGroup(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `user-group/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  createUserGroup(params) {
    return HTTP.post(apiBaseUrl + `user-group`, params);
  },
  updateUserGroup(group_id, params) {
    return HTTP.put(apiBaseUrl + `user-group/` + group_id, params)
  },

  /* Checklist From Templates */
  getChecklistFromTemplates(params) {
    return HTTP.get(apiBaseUrl + `checklist-form-template`, params)
  },
  getChecklistFromTemplatesDetails(params) {
    return HTTP.get(apiBaseUrl + `checklist-form-template/` + params)
  },
  deleteChecklistFromTemplates(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `checklist-form-template/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  createChecklistFromTemplates(params) {
    return HTTP.post(apiBaseUrl + `checklist-form-template`, params);
  },
  updateChecklistFromTemplates(cid, params) {
    return HTTP.put(apiBaseUrl + `checklist-form-template/` + cid, params)
  },
  restoreChecklistFromTemplates(params) {
    return HTTP.post(apiBaseUrl + `restore-checklist-form-template`, params)
  },
  permanentChecklistFromTemplatesRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-checklist-form-template`, params)
  },
  getDeleteChecklistFromTemplates() {
    return HTTP.get(apiBaseUrl + `deleted-checklist-form-template`);
  },

  /* Stage Status */
  getStageStatus(params) {
    return HTTP.get(apiBaseUrl + `stage-status`, params)
  },
  getStageStatusDetails(params) {
    return HTTP.get(apiBaseUrl + `stage-status/` + params)
  },
  deleteStageStatus(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `stage-status/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  createStageStatus(params) {
    return HTTP.post(apiBaseUrl + `stage-status`, params);
  },
  updateStageStatus(cid, params) {
    return HTTP.put(apiBaseUrl + `stage-status/` + cid, params)
  },
  restoreStageStatus(params) {
    return HTTP.post(apiBaseUrl + `restore-stage-status`, params)
  },
  permanentStageStatusRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-stage-status`, params)
  },
  getDeleteStageStatus() {
    return HTTP.get(apiBaseUrl + `deleted-stage-status`);
  },

  /*
  * Students Diagnosis
  */
  getStudentDiagnosis(student_id, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `student/diagnosis/` + student_id + '?';

    if (!_.isEmpty(params)) {
      url = url + `&page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  createStudentDiagnosis(params) {
    return HTTP.post(apiBaseUrl + `student-diagnosis`, params)
  },
  updateStudentDiagnosis(diagnosis_id, params) {
    return HTTP.put(apiBaseUrl + `student-diagnosis/` + diagnosis_id, params)
  },
  deleteStudentDiagnosis(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `student-diagnosis/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  getStudentDiagnosisDetails(params) {
    return HTTP.get(apiBaseUrl + `student-diagnosis/` + params)
  },

  getAllStudents(params, serviceId = "", staffId = "", limit = 50) {
    return HTTP.get(apiBaseUrl + `all-students?search=` + params + `&service_line_id=` + serviceId + `&staff_id=` + staffId + `&limit=` + limit)
  },

  getAllSkillAreas() {
    return HTTP.get(apiBaseUrl + `skill-area-list`);
  },

  /*
  * Students Contact
  */
  getStudentContacts(student_id, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `student/contacts/` + student_id + `?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getStudentPersonalContacts(student_id, params) {
    return HTTP.get(apiBaseUrl + `student/personal-contacts/` + student_id, params)
  },
  createStudentContact(params) {
    return HTTP.post(apiBaseUrl + `student-contact`, params)
  },
  updateStudentContact(contact_id, params) {
    return HTTP.put(apiBaseUrl + `student-contact/` + contact_id, params)
  },
  deleteStudentContact(params) {
    return HTTP.delete(apiBaseUrl + `student-contact/` + params)
  },
  updateStudentContactEmail(contact_id, params) {
    return HTTP.put(apiBaseUrl + `update-contact-email/` + contact_id, params)
  },
  getStudentContactDetails(params) {
    return HTTP.get(apiBaseUrl + `student-contact/` + params)
  },
  getStudentSchoolContacts(student_id, params) {
    return HTTP.get(apiBaseUrl + `student/school-contacts/` + student_id, params)
  },
  /*
  * Students Assesment
  */
  getStudentAssessments(student_id, params) {
    return HTTP.get(apiBaseUrl + `student/assessments/` + student_id, params)
  },
  getStudentPreferenceAssessments(student_id, catId, params) {
    return HTTP.get(apiBaseUrl + `student/preference/assessments/` + student_id + `/` + catId, params)
  },
  updateStudentPreferenceAssessment(student_id, catId, params) {
    return HTTP.post(apiBaseUrl + `student/preference-assessements/update/` + student_id + `/` + catId, params)
  },
  getStudentSkillAssessments(student_id, catId, params) {
    return HTTP.get(apiBaseUrl + `student/skill/assessments/` + student_id + `/` + catId, params)
  },
  updateStudentSkillAssessment(student_id, catId, params) {
    return HTTP.post(apiBaseUrl + `student/skill-assessement/update/` + student_id + `/` + catId, params)
  },
  getStudentHealthAssessments(student_id, catId, params) {
    return HTTP.get(apiBaseUrl + `student/health/assessments/` + student_id + `/` + catId, params)
  },
  updateStudentHealthAssessment(student_id, catId, params) {
    return HTTP.post(apiBaseUrl + `student/health-assessement/update/` + student_id + `/` + catId, params)
  },
  createStudentAssessment(params) {
    return HTTP.post(apiBaseUrl + `assessment-student`, params)
  },
  deleteStudentAssessment(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `assessment-student/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  getStudentAssessmentDetails(params) {
    return HTTP.get(apiBaseUrl + `assessment-student/` + params)
  },
  /*
  * Payer Plans
  */
  getPayerPlans(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `payers-plan?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getPayerPlanDetails(params) {
    return HTTP.get(apiBaseUrl + `payers-plan/` + params)
  },
  createPayerPlan(params) {
    return HTTP.post(apiBaseUrl + `payers-plan`, params)
  },
  updatePayerPlan(plan_id, params) {
    return HTTP.put(apiBaseUrl + `payers-plan/` + plan_id, params)
  },
  deletePayerPlan(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `payers-plan/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  restorePayerPlan(params) {
    return HTTP.post(apiBaseUrl + `restore-payers-plan`, params)
  },
  permanentPayerPlanRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-payers-plan`, params)
  },
  getDeletePayerPlans() {
    return HTTP.get(apiBaseUrl + `deleted-payers-plan`);
  },
  getPayerPlansByPayerId(payer_id) {
    return HTTP.get(apiBaseUrl + `payers-plan-by-payerid/` + payer_id);
  },
  /*
  * Language
  */
  getLanguage(params) {
    return HTTP.get(apiBaseUrl + `languages`, params)
  },
  /*
  * Locations
  */
  getLocations(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `locations?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getAllLocations(params) {
    return HTTP.get(apiBaseUrl + `all-locations`, params)
  },
  getLocationDetails(params) {
    return HTTP.get(apiBaseUrl + `locations/` + params)
  },
  createLocation(params) {
    return HTTP.post(apiBaseUrl + `locations`, params)
  },
  updateLocation(location_id, params) {
    return HTTP.put(apiBaseUrl + `locations/` + location_id, params)
  },
  deleteLocation(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `locations/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  restoreLocation(params) {
    return HTTP.post(apiBaseUrl + `restore-locations`, params)
  },
  permanentLocationRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-locations`, params)
  },
  getDeleteLocations(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `deleted-locations?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  /*
  *   Student ServiceLine/Funders
  */
  getStudentFunder(student_id, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `student/service/` + student_id + `?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getStudentFunderDetails(params) {
    return HTTP.get(apiBaseUrl + `student-service/` + params)
  },
  createStudentFunder(params) {
    return HTTP.post(apiBaseUrl + `student-service`, params)
  },
  updateStudentFunder(funder_id, params) {
    return HTTP.put(apiBaseUrl + `student-service/` + funder_id, params)
  },
  deleteStudentFunder(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `student-service/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  getStudentFunders(student_id) {
    return HTTP.get(apiBaseUrl + `student-funder/` + student_id)
  },
  getStudentFunderServiceLines(student_id, funder_id) {
    return HTTP.get(apiBaseUrl + `student/funder/serviceline/` + student_id + `/` + funder_id)
  },
  /*
  * Student Authorization
  */
  createStudentAuthorization(params) {
    return HTTP.post(apiBaseUrl + `student-authorization`, params);
  },
  getStudentAuthorization(user_id, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `student-authorization/list/` + user_id + '?';

    if (!_.isEmpty(params)) {
      url = url + `&page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getServicesByStudentAuhorization(params) {
    return HTTP.post(apiBaseUrl + `student-authorization/services`, params);
  },
  getStudentAuthorizationDetails(params) {
    return HTTP.get(apiBaseUrl + `student-authorization/` + params)
  },
  updateStudentAuthorization(edit_id, params) {
    return HTTP.put(apiBaseUrl + `student-authorization/` + edit_id, params)
  },
  deleteStudentAuthorization(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `student-authorization/` + params)
  },
  deleteStudentAuthorizationPermanently(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.post(apiBaseUrl + `student-auth-permanent-delete`, params)
  },
  restoreStudentAuthorization(params) {
    return HTTP.post(apiBaseUrl + `student-auth-restore`, params)
  },
  getStudentAuthorizationServices(student_id) {
    return HTTP.get(apiBaseUrl + `student-authorization-services/` + student_id);
  },
  getStudentAuthorizationsByBCBA(id) {
    return HTTP.get(apiBaseUrl + `student-authorization-by-bcbausers/` + id);
  },
  getAllAuthStaffByStudents(params) {
    return HTTP.post(apiBaseUrl + `all-staff-student-authorization`, params);
  },
  getStudentAuthorizationServiceBillingCodes(authorization_id) {
    return HTTP.get(apiBaseUrl + `student-authorization-services-billing-codes/` + authorization_id);
  },
  getAuthDetailsByStudentParams(params) {
    return HTTP.post(apiBaseUrl + `student-auth-by-params`, params);
  },

  /*
  * Student Goal
  */
  createStudentGoal(student_id, params) {
    return HTTP.post(apiBaseUrl + `student-goals/` + student_id, params);
  },
  // getStudentGoals(student_id, param){
  //   return HTTP.get(apiBaseUrl+`student-goals/`+student_id, param);
  // },
  getStudentGoals(student_id, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `student-goals/` + student_id + '?';

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getStudentGoalDetails(goal_id, params) {
    return HTTP.get(apiBaseUrl + `student-goal/` + goal_id, params)
  },
  deleteStudentGoal(goal_id) {
    return HTTP.delete(apiBaseUrl + `student-goal/` + goal_id)
  },
  updateStudentGoal(student_id, goal_id, params) {
    return HTTP.post(apiBaseUrl + `student-goal-edit/` + student_id + `/` + goal_id, params)
  },

  /*
  * Student Program Target
  */
  getProgramTreeStructure(params) {
    return HTTP.post(apiBaseUrl + `student-program-tree-structure`, params);
  },
  getStudentTargetProgramId(params) {
    return HTTP.post(apiBaseUrl + `student-target-program-id`, params);
  },
  createStudentProgramTarget(params) {
    return HTTP.post(apiBaseUrl + `student-program-target`, params);
  },
  getProgramTargetByStatus(params) {
    return HTTP.post(apiBaseUrl + `student-program-by-status`, params);
  },
  getAllTargets() {
    return HTTP.get(apiBaseUrl + `all-targets`);
  },

  /*
  * Student PromptCode
  */
  createStudentPromptcode(student_id, params) {
    return HTTP.post(apiBaseUrl + `student-promptcode/` + student_id, params);
  },
  getStudentPromptcode(student_id, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `student-promptcodes/` + student_id + '?';

    if (!_.isEmpty(params)) {
      url = url + `&page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getStudentPromptcodeDetails(promptcode_id, params) {
    return HTTP.get(apiBaseUrl + `student-promptcode/` + promptcode_id, params)
  },
  updateStudentPromptcode(student_id, promptcode_id, params) {
    return HTTP.post(apiBaseUrl + `student-promptcode-edit/` + student_id + `/` + promptcode_id, params)
  },
  studentPromptcode(studentId) {
    return HTTP.get(apiBaseUrl + `get-student-prompt-code/` + studentId);
  },
  updatePromptCodeOverride(params) {
    return HTTP.post(apiBaseUrl + `update-student-promptcode-override`, params);
  },
  checkpromptOverrideStatus(student_id) {
    return HTTP.get(apiBaseUrl + `check-prompt-code-override-status/` + student_id);
  },
  deleteStudentPromptcode(prompt_id) {
    // console.log(prompt_id);
    return HTTP.delete(apiBaseUrl + `student-promptcode-delete/` + prompt_id);
  },

  /*
  * Student Prompt Schedule
  */
  getStudentPromptSchedule(id, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `student-prompt-schedule-list/` + id;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getStudentPromptScheduleDetails(params) {
    return HTTP.get(apiBaseUrl + `student-prompt-schedule/` + params)
  },
  createStudentPromptSchedule(params) {
    return HTTP.post(apiBaseUrl + `student-prompt-schedule`, params);
  },
  updateStudentPromptSchedule(edit_id, params) {
    return HTTP.put(apiBaseUrl + `student-prompt-schedule/` + edit_id, params)
  },
  deleteStudentPromptSchedule(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `student-prompt-schedule/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },

  /*
  * Student Interval Schedule
  */
  getStudentIntervalSchedulePagination(params) {
    let studentId = params.studentId;
    delete params.studentId;
    return HTTP.get(apiBaseUrl + `student-interval-schedule-list/` + studentId, { params });
  },
  getStudentIntervalSchedule(params) {
    return HTTP.get(apiBaseUrl + `student-interval-schedule-list/` + params);
  },
  getStudentIntervalScheduleDetails(params) {
    return HTTP.get(apiBaseUrl + `student-interval-schedule/` + params)
  },
  createStudentIntervalSchedule(params) {
    return HTTP.post(apiBaseUrl + `student-interval-schedule`, params);
  },
  updateStudentIntervalSchedule(edit_id, params) {
    return HTTP.put(apiBaseUrl + `student-interval-schedule/` + edit_id, params)
  },
  deleteStudentIntervalSchedule(params) {
    return HTTP.delete(apiBaseUrl + `student-interval-schedule/` + params)
  },

  /*
  * Student Referring Providers
  */
  getStudentReferringProviders(student_id, params) {
    let url = apiBaseUrl + `student/referring-providers/${student_id}`;
    if (!_.isEmpty(params)) {
      url = url + `?page=` + params.page + `&per_page=` + params.perPage;
    }

    return HTTP.get(url);
  },


  /*
  * Session Template Type
  */
  getSessionTemplateType(params) {
    return HTTP.get(apiBaseUrl + `session-template-type`, params);
  },
  getSessionTemplateTypeDetails(params) {
    return HTTP.get(apiBaseUrl + `session-template-type/` + params)
  },
  createSessionTemplateType(params) {
    return HTTP.post(apiBaseUrl + `session-template-type`, params);
  },
  updateSessionTemplateType(id, params) {
    return HTTP.put(apiBaseUrl + `session-template-type/` + id, params)
  },
  deleteSessionTemplateType(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `session-template-type/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  restoreSessionTemplateType(params) {
    return HTTP.post(apiBaseUrl + `restore-session-template-type`, params)
  },
  permanentSessionTemplateTypeRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-session-template-type`, params)
  },
  getDeleteSessionTemplateType() {
    return HTTP.get(apiBaseUrl + `deleted-session-template-type`);
  },
  getDocConversionDetails(id, params) {
    return HTTP.post(apiBaseUrl + `import-doc-dynamic-session-template/` + id, params);
  },

  /*
  * Session Template Master
  */
  getSessionTemplateMaster(params) {
    return HTTP.get(apiBaseUrl + `session-template-master`, params);
  },
  getSessionTemplateMasterDetails(params) {
    return HTTP.get(apiBaseUrl + `session-template-master/` + params)
  },
  createSessionTemplateMaster(params) {
    return HTTP.post(apiBaseUrl + `session-template-master`, params);
  },
  updateSessionTemplateMaster(id, params) {
    return HTTP.put(apiBaseUrl + `session-template-master/` + id, params)
  },
  deleteSessionTemplateMaster(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `session-template-master/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  restoreSessionTemplateMaster(params) {
    return HTTP.post(apiBaseUrl + `restore-session-template-master`, params)
  },
  permanentSessionTemplateMasterRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-session-template-master`, params)
  },
  getDeleteSessionTemplateMaster() {
    return HTTP.get(apiBaseUrl + `deleted-session-template-master`);
  },

  /*
  * Session Template Form
  */
  getSessionTemplateForm(params) {
    return HTTP.get(apiBaseUrl + `session-form-template`, params);
  },
  getSessionTemplateFormDetails(params) {
    return HTTP.get(apiBaseUrl + `session-form-template/` + params)
  },
  createSessionTemplateForm(params) {
    return HTTP.post(apiBaseUrl + `session-form-template`, params);
  },
  updateSessionTemplateForm(id, params) {
    return HTTP.put(apiBaseUrl + `session-form-template/` + id, params)
  },
  deleteSessionTemplateForm(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `session-form-template/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  restoreSessionTemplateForm(params) {
    return HTTP.post(apiBaseUrl + `restore-session-form-template`, params)
  },
  permanentSessionTemplateFormRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-session-form-template`, params)
  },
  getDeleteSessionTemplateForm() {
    return HTTP.get(apiBaseUrl + `deleted-session-form-template`);
  },
  verifySignature(params) {
    return HTTP.post(apiBaseUrl + `verify-session-template`, params);
  },
  requestVerificationSession(params) {
    return HTTP.post(apiBaseUrl + `request-verification`, params);
  },
  getSessionFiles(session_id) {
    return HTTP.get(apiBaseUrl + `get-session-files/` + session_id);
  },
  updateSessionFiles(params) {
    return HTTP.post(apiBaseUrl + `update-session-files`, params);
  },
  removeSessionFile(params) {
    return HTTP.post(apiBaseUrl + `remove-session-files`, params);
  },

  /*
  * Message
  */
  getMessage(params) {
    return HTTP.get(apiBaseUrl + `message`, params)
  },
  getMessageDetails(id, params) {
    return HTTP.get(apiBaseUrl + `message/` + id, params)
  },
  getSentMessage(params) {
    return HTTP.get(apiBaseUrl + `sent-message`, params)
  },
  deleteMessage(id, params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `message/` + id + `?redirect_to=` + window.location.origin + `/delete-` + pathName, params)
  },
  createMessage(params) {
    return HTTP.post(apiBaseUrl + `message`, params);
  },
  updateMessag(id, params) {
    return HTTP.put(apiBaseUrl + `message/` + id, params)
  },
  restoreMessage(params) {
    return HTTP.post(apiBaseUrl + `restore-message`, params)
  },
  permanentMessageRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-message`, params)
  },
  getDeleteMessage() {
    return HTTP.get(apiBaseUrl + `deleted-message`);
  },
  ExportMessage() {
    return HTTP.get(apiBaseUrl + `export-message`);
  },
  ReplyMessage(params) {
    return HTTP.post(apiBaseUrl + `reply-message`, params);
  },
  /*
  * Reminder
  */
  getReminder(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `reminder?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getReminderDetails(params) {
    return HTTP.get(apiBaseUrl + `reminder/` + params)
  },
  createReminder(params) {
    return HTTP.post(apiBaseUrl + `reminder`, params);
  },
  updateReminder(id, params) {
    return HTTP.put(apiBaseUrl + `reminder/` + id, params)
  },
  deleteReminder(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `reminder/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  runReminder(rem_id) {
    return HTTP.get(apiBaseUrl + `run-reminder/` + rem_id)
  },
  /*
  * Student Behavior
  */
  // getStudentBehavior(params){
  //   return HTTP.post(apiBaseUrl+`student-behavior-list`,params)
  // },
  getStudentBehaviorList(student_id, type, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `student-behavior?studentId=` + student_id + '&type=' + type;

    if (!_.isEmpty(params)) {
      url = url + `&page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getStudentBehavior(student_id, type, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `student-behavior-list?studentId=` + student_id + '&type=' + type;

    if (!_.isEmpty(params)) {
      url = url + `&page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.post(url);
  },
  createStudentBehavior(params) {
    return HTTP.post(apiBaseUrl + `student-behavior`, params);
  },
  getStudentBehaviorDetails(parent_id) {
    return HTTP.get(apiBaseUrl + `student-behavior/` + parent_id)
  },
  updateStudentBehavior(edit_id, params) {
    return HTTP.put(apiBaseUrl + `student-behavior/` + edit_id, params)
  },
  deleteStudentBehavior(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `student-behavior/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },

  /* Program Category */
  getCategories(params) {
    return HTTP.get(apiBaseUrl + `program-category`, params)
  },
  getParentCategories(student_id, params) {
    return HTTP.get(apiBaseUrl + `program/parent-category/` + student_id, params)
  },
  getChildCategories(parent_id, student_id) {
    return HTTP.get(apiBaseUrl + `program/sub-category/` + parent_id + `/` + student_id)
  },
  getAllChildCategories(student_id, params) {
    return HTTP.get(apiBaseUrl + `programs/all-sub-category/` + student_id, params)
  },
  deleteCategory(id) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `program-category/` + id + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  createCategory(params) {
    return HTTP.post(apiBaseUrl + `program-category`, params);
  },
  updateCategory(cat_id, params) {
    return HTTP.put(apiBaseUrl + `program-category/` + cat_id, params)
  },
  getCategoryDetails(params) {
    return HTTP.get(apiBaseUrl + `program-category/` + params)
  },
  restoreCategories(params) {
    return HTTP.post(apiBaseUrl + `restore-program-category`, params)
  },
  permanentCategoriesRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-program-category`, params)
  },
  cloneCategory(cat_id) {
    return HTTP.get(apiBaseUrl + `clone-program-category/` + cat_id);
  },


  /*
  * Behavior Category
  */
  getBehaviorCategory(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `behavior-category?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getBehaviorCategoryDetails(params) {
    return HTTP.get(apiBaseUrl + `behavior-category/` + params)
  },
  createBehaviorCategory(params) {
    return HTTP.post(apiBaseUrl + `behavior-category`, params)
  },
  updateBehaviorCategory(edit_id, params) {
    return HTTP.put(apiBaseUrl + `behavior-category/` + edit_id, params)
  },
  deleteBehaviorCategory(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `behavior-category/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  restoreBehaviorCategory(params) {
    return HTTP.post(apiBaseUrl + `restore-behavior-category`, params)
  },
  permanentBehaviorCategoryRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-behavior-category`, params)
  },
  getDeleteBehaviorCategory(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `deleted-behavior-category?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },

  /*
  * Behavior
  */
  getBehavior(params) {
    return HTTP.get(apiBaseUrl + `behavior`, params)
  },
  getBehaviorDetails(params) {
    return HTTP.get(apiBaseUrl + `behavior/` + params)
  },

  /*
  * Program (Program Target)
  */
  // getProgramList(params) {
  //   return  HTTP.get(apiBaseUrl+`student-program`, params)
  // },
  getProgramList(student_id, cat_id, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `student-program?student_id=` + student_id + `&cat_id=` + cat_id;

    if (!_.isEmpty(params)) {
      url = url + `&page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      // url = url+`&agency_name=`+data.agency_name+`&student_name=`+data.student_name+`&funder_name=`+data.funder_name+`&staff_name=`+data.staff_name;
      // url = url
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getStudentProgramList(student_id, category_id, params) {
    return HTTP.get(apiBaseUrl + `student-program-list/` + student_id + '/' + category_id, params)
  },
  createStudentProgram(params) {
    return HTTP.post(apiBaseUrl + `student-program`, params)
  },
  // getStudentProgramDetails(params) {
  //   return  HTTP.get(apiBaseUrl+`student-program/`+params)
  // },
  getStudentProgramDetails(id) {
    return HTTP.get(apiBaseUrl + `student-program/` + id)
  },
  updateStudentProgram(edit_id, params) {
    return HTTP.put(apiBaseUrl + `student-program/` + edit_id, params)
  },
  deleteStudentProgram(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `student-program/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  studentProgramImport(params) {
    return HTTP.post(apiBaseUrl + 'student-program-import', params)
  },
  getStudentProgramGoal(params) {
    return HTTP.post(apiBaseUrl + `all-student-program`, params)
  },
  getStudentStaffProgramGoal(student_id, staff_id) {
    return HTTP.get(apiBaseUrl + `all-student-staff-program/` + student_id + `/` + staff_id)
  },
  getSelectedStudentProgGoals(params) {
    return HTTP.post(apiBaseUrl + `selected-student-program`, params);
  },
  ExportStudentPrograms(params) {
    return HTTP.post(apiBaseUrl + `export-student-program`, params);
  },

  /*
  * Program Target Types
  */
  getAllTargetTypes(params) {
    return HTTP.get(apiBaseUrl + `program-target-type-all`, params)
  },
  getAllProgramTargetTypes(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `program-target-type?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getTargetTypes(params) {
    return HTTP.get(apiBaseUrl + `program-target-type`, params)
  },
  getTargetTypeDetails(params) {
    return HTTP.get(apiBaseUrl + `program-target-type/` + params)
  },
  deleteTargetType(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `program-target-type/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  createTargetType(params) {
    return HTTP.post(apiBaseUrl + `program-target-type`, params);
  },
  updateTargetType(cid, params) {
    return HTTP.put(apiBaseUrl + `program-target-type/` + cid, params)
  },
  restoreTargetType(params) {
    return HTTP.post(apiBaseUrl + `restore-target-type`, params)
  },
  permanentTargetTypeRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-target-type`, params)
  },
  getDeleteTargetType(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `deleted-target-type?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },

  /*
  * Student Target Playlist
  */
  getPlaylistDetails(student_id, program_id) {
    return HTTP.get(apiBaseUrl + `student-program-playlist/` + student_id + '/' + program_id);
  },
  updatePlaylist(params) {
    return HTTP.post(apiBaseUrl + `student-program-update-playlist`, params);
  },
  /*
  * Behavior Data Entry
  */
  getAbcDataList(params) {
    return HTTP.post(apiBaseUrl + `behavior-abc-data-entry/list`, params);
  },
  addAbcData(params) {
    return HTTP.post(apiBaseUrl + `behavior-abc-data-entry`, params)
  },
  updateAbcData(id, params) {
    return HTTP.put(apiBaseUrl + `behavior-abc-data-entry/` + id, params)
  },
  deleteAbcData(id) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `behavior-abc-data-entry/` + id + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },

  /*
  * Behavior Data
  */
  addBehaviorData(params) {
    return HTTP.post(apiBaseUrl + `behavior-data-entry`, params)
  },
  detailsBehaviorData(params) {
    return HTTP.post(apiBaseUrl + `behavior-data-entry-details`, params)
  },

  /*
 * Intake Form
 */

  addIntakeForm(params) {
    return HTTP.post(apiBaseUrl + `intake-form`, params)
  },
  getIntakeFormbById(id) {
    return HTTP.get(apiBaseUrl + `intake-form/` + id);
  },
  intakeFormList(param) {
    return HTTP.get(apiBaseUrl + `intake-form`, param);
  },
  AllintakeForms(param) {
    return HTTP.get(apiBaseUrl + `all-intake-forms`, param);
  },
  updateIntakeForm(param) {
    return HTTP.put(apiBaseUrl + `intake-form/` + param.id, param);
  },
  deleteIntakeForm(id) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `intake-form/` + id + `?redirect_to=` + window.location.origin + `/delete-` + pathName);
  },
  updateStudentIntakeForm(params) {
    return HTTP.put(apiBaseUrl + `student-intake-form/` + params.id, params)
  },
  updateGuestIntakeForm(params) {
    return HTTP.post(apiBaseUrl + `student-intake-form-update/` + params.id, params)
  },
  submitStudentIntakeForm(params) {
    return HTTP.post(apiBaseUrl + `student-intake-form`, params)
  },
  cloneIntakeForm(params) {
    return HTTP.post(apiBaseUrl + `intake-form-clone`, params)
  },
  getStudentIntakeForm(params) {
    return HTTP.get(apiBaseUrl + `student-intake-form-list/` + params)
  },
  deleteStudentIntakeForm(id) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `student-intake-form/` + id + `?redirect_to=` + window.location.origin + `/delete-` + pathName);
  },
  getStudentIntakeFormById(id) {
    return HTTP.get(apiBaseUrl + `student-intake-form/` + id);
  },
  getStudentIntakeFormShowById(id) {
    return HTTP.get(apiBaseUrl + `student-intake-form-show/` + id);
  },
  studentIntakeFormExport(params) {
    return HTTP.post(apiBaseUrl + `student-intake-form-export`, params);
  },
  checkIntakeFormStatus(params) {
    return HTTP.post(apiBaseUrl + `check-intake-form-status`, params);
  },
  updateIntakeFormStatus(params) {
    return HTTP.post(apiBaseUrl + `update-intake-form-status`, params);
  },

  /*
  * Student Program Skill Data Entry
  */

  addSkillDataEntry(params) {
    return HTTP.post(apiBaseUrl + `student-program-target-data`, params)
  },
  getSkillDataList(student_id, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `student-program-target-data-list/` + student_id + '?';

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      // url = url+`&agency_name=`+data.agency_name+`&student_name=`+data.student_name+`&funder_name=`+data.funder_name+`&staff_name=`+data.staff_name;
      // url = url
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },

  /*
   * Calender && appointment
   */
  appointmentScheduleCheck(params) {
    return HTTP.post(apiBaseUrl + `schedule-check`, params);
  },
  createAppointment(params) {
    return HTTP.post(apiBaseUrl + `appointment`, params);
  },
  getAppointmentDetails(params) {
    return HTTP.get(apiBaseUrl + `appointment/` + params)
  },
  updateAppointmentDetails(app_id, params) {
    return HTTP.put(apiBaseUrl + `appointment/` + app_id, params)
  },
  deleteAppointment(id) {
    let pathName = window.location.pathname.replace('/', '');
    // return HTTP.delete(apiBaseUrl+`appointment/`+id+`?redirect_to=`+window.location.origin+`/delete-`+pathName);
    return HTTP.delete(apiBaseUrl + `appointment/` + id);
  },
  appointmentsFilter(params) {
    return HTTP.post(apiBaseUrl + `appointments-filter`, params)
  },
  appointmentList(params) {
    return HTTP.post(apiBaseUrl + `appoitment-list`, params)
  },
  deleteAppointments(params) {
    return HTTP.post(apiBaseUrl + `delete-appointment`, params)
  },
  getSessionEventFilter(params) {
    return HTTP.post(apiBaseUrl + `get-event-session-filter`, params)
  },
  ExportSessions(params) {
    return HTTP.post(apiBaseUrl + `export-session`, params);
  },
  verifySignatureMulti(params) {
    return HTTP.post(apiBaseUrl + `verify-sign`, params);
  },
  verifySignatureMultiNew(params) {
    return HTTP.post(apiBaseUrl + `all-verify-sign`, params);
  },
  requestSignatureMultiNew(params) {
    return HTTP.post(apiBaseUrl + `all-sign-request`, params);
  },
  requestSignatureMulti(params) {
    return HTTP.post(apiBaseUrl + `sent-sign-request`, params);
  },
  // deprecated
  // saveAppointmentFile(params){
  //   return HTTP.post(apiBaseUrl+`save-appointment-file`, params)
  // },
  filterAppointmentEventCalendar(params) {
    return HTTP.post(apiBaseUrl + `appoitment-list-filter`, params);
  },
  filterStudentBillableEventCalendar(params) {
    return HTTP.post(apiBaseUrl + `billing-schedule-filter`, params);
  },

  /*
  * Session Form Category
  */
  getSessionFormParentCategoryByType(type, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `session-form-category-bytype/` + type + `?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getSessionFormCategory(params) {
    return HTTP.get(apiBaseUrl + `session-form-category`, params)
  },
  getSessionFormSubCategory(parent_id, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `session-form-sub-category/` + parent_id + `?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getSessionFormParentCategory(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `session-form-parent-category?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getSessionFormCategoryDetails(params) {
    return HTTP.get(apiBaseUrl + `session-form-category/` + params)
  },
  deleteSessionFormCategory(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `session-form-category/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  createSessionFormCategory(params) {
    return HTTP.post(apiBaseUrl + `session-form-category`, params);
  },
  updateSessionFormCategory(cid, params) {
    return HTTP.put(apiBaseUrl + `session-form-category/` + cid, params)
  },
  sessionFromAllCategory(params = '') {
    return HTTP.get(apiBaseUrl + `session-form-all-categories?service=` + params)
  },

  /*
  * Session Form template
  */
  getSessionFormTemplate(params) {
    return HTTP.get(apiBaseUrl + `session-form-template`, params)
  },
  getStudentSessionFormTemplate(student_id, user_id, user_type) {
    if (user_id && user_type) {
      return HTTP.get(apiBaseUrl + `session-form-template-student/` + student_id + `/` + user_id + `/` + user_type);
    } else {
      return HTTP.get(apiBaseUrl + `session-form-template-student/` + student_id)
    }

  },
  getSessionFormTemplateDetails(params) {
    return HTTP.get(apiBaseUrl + `session-form-template/` + params)
  },
  deleteSessionFormTemplate(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `session-form-template/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  createSessionFormTemplate(params) {
    return HTTP.post(apiBaseUrl + `session-form-template`, params);
  },
  updateSessionFormTemplate(template_id, params) {
    return HTTP.put(apiBaseUrl + `session-form-template/` + template_id, params)
  },
  getGuestSessionTemplate(encrypt_id) {
    return HTTP.get(apiBaseUrl + `guest-session-form-template/` + encrypt_id)
  },
  getStudentSessionFormTemplateByEvent(event_id) {
    return HTTP.get(apiBaseUrl + `session-form-template-eventid/` + event_id)
  },
  sessionFormTemplateReport(params) {
    return HTTP.post(apiBaseUrl + `session-form-template-report`, params);
  },
  sessionFormSelectedAllCodeReport(params) {
    return HTTP.post(apiBaseUrl + `session-form-template-report-per-date`, params);
  },
  sessionFormSelectedMultipleReport(params) {
    return HTTP.post(apiBaseUrl + `session-form-template-report-multiple-date`, params);
  },
  sessionFormTemplateFunderChecking(params) {
    return HTTP.post(apiBaseUrl + `session-form-template-report-funder-check`, params);
  },


  /*
  * Skill Area
  */
  getSkillArea(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `skill-area?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getSkillAreaDetails(params) {
    return HTTP.get(apiBaseUrl + `skill-area/` + params)
  },
  createSkillArea(params) {
    return HTTP.post(apiBaseUrl + `skill-area`, params);
  },
  updateSkillArea(billingcode_id, params) {
    return HTTP.put(apiBaseUrl + `skill-area/` + billingcode_id, params)
  },
  deleteSkillArea(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `skill-area/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  restoreSkillArea(params) {
    return HTTP.post(apiBaseUrl + `restore-skill-area`, params)
  },
  permanentSkillAreaRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-skill-area`, params)
  },
  getDeleteSkillArea(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `deleted-skill-area?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  ExportSkillArea() {
    return HTTP.post(apiBaseUrl + `export-skill-area`);
  },
  ImportSkillArea(params) {
    return HTTP.post(apiBaseUrl + `import-skill-area`, params);
  },

  /*
  * BCBA Task
  */
  getBCBATask(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `bcba-task?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getBCBATaskDetails(params) {
    return HTTP.get(apiBaseUrl + `bcba-task/` + params)
  },
  createBCBATask(params) {
    return HTTP.post(apiBaseUrl + `bcba-task`, params);
  },
  updateBCBATask(billingcode_id, params) {
    return HTTP.put(apiBaseUrl + `bcba-task/` + billingcode_id, params)
  },
  deleteBCBATask(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `bcba-task/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  restoreBCBATask(params) {
    return HTTP.post(apiBaseUrl + `restore-bcba-task`, params)
  },
  permanentBCBATaskRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-bcba-task`, params)
  },
  getDeleteBCBATask(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `deleted-bcba-task?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  ExportBCBATask() {
    return HTTP.post(apiBaseUrl + `export-bcba-task`);
  },
  ImportBCBATask(params) {
    return HTTP.post(apiBaseUrl + `import-bcba-task`, params);
  },

  /*
  * Session Template
  */
  getSessionTemplate(params) {
    return HTTP.get(apiBaseUrl + `session-template`, params);
  },
  getSessionTemplateDetails(params) {
    return HTTP.get(apiBaseUrl + `session-template/` + params)
  },
  createSessionTemplate(params) {
    return HTTP.post(apiBaseUrl + `session-template`, params);
  },
  updateSessionTemplate(billingcode_id, params) {
    return HTTP.put(apiBaseUrl + `session-template/` + billingcode_id, params)
  },
  deleteSessionTemplate(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `session-template/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  restoreSessionTemplate(params) {
    return HTTP.post(apiBaseUrl + `restore-session-template`, params)
  },
  permanentSessionTemplateRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-session-template`, params)
  },
  getDeleteSessionTemplate() {
    return HTTP.get(apiBaseUrl + `deleted-session-template`);
  },
  getStudentTargetDataNoteHelper(params) {
    return HTTP.post(apiBaseUrl + `program-target-data-note-helper`, params);
  },
  getPlaylistDataNoteHelper(params) {
    return HTTP.post(apiBaseUrl + `playlist-data-note-helper`, params);
  },
  getProgramTargetDataNoteHelper(params) {
    return HTTP.post(apiBaseUrl + `programtarget-data-note-helper`, params);
  },
  getTemplateByService(service_id, type) {
    return HTTP.get(apiBaseUrl + `template-by-service/` + service_id + `/` + type);
  },

  /*
  * Dynamic Session Template
  */
  getDynamicSessionTemplate(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `dynamic-session-template?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
      if (params.source_type && params.source_type != '') {
        url = url + `&source_type=` + params.source_type;
      }
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search + `&payers=` + data?.payers;
    }

    if (Array.isArray(data.hcodes)) {
      data.hcodes.forEach(code => {
        url += `&hcodes[]=${encodeURIComponent(code)}`;
      });
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getDynamicSessionTemplateDetails(params) {
    return HTTP.get(apiBaseUrl + `dynamic-session-template/` + params)
  },
  createDynamicSessionTemplate(params) {
    return HTTP.post(apiBaseUrl + `dynamic-session-template`, params);
  },
  updateDynamicSessionTemplate(template_id, params) {
    return HTTP.put(apiBaseUrl + `dynamic-session-template/` + template_id, params)
  },
  deleteDynamicSessionTemplate(params) {
    return HTTP.delete(apiBaseUrl + `dynamic-session-template/` + params )
  },
  cloneDynamicSessionTemplate(id, params = {}) {
    return HTTP.post(apiBaseUrl + `dynamic-session-template/clone/` + id, params);
  },
  getDynamicSessionTemplateHcodes(params) {
    return HTTP.get(apiBaseUrl + `dynamic-session-template-hcodes`, params);
  },
  getBillingCodes() {
    return HTTP.get(apiBaseUrl + `dynamic-session-template/billing-codes/get`);
  },

  /*
  * Target Accuracy
  */
  getTargetAccuracy(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `target-accuracy?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  createTargetAccuracy(params) {
    return HTTP.post(apiBaseUrl + `target-accuracy`, params);
  },
  getTargetAccuracyDetails(params) {
    return HTTP.get(apiBaseUrl + `target-accuracy/` + params);
  },
  updateTargetAccuracy(target_accuracy_id, params) {
    return HTTP.put(apiBaseUrl + `target-accuracy/` + target_accuracy_id, params);
  },
  deleteTargetAccuracy(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `target-accuracy/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName);
  },
  getDeleteTargetAccuracy(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `deleted-target-accuracy?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  permanentTargetAccuracyRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-target-accuracy`, params)
  },
  restoreTargetAccuracy(params) {
    return HTTP.post(apiBaseUrl + `restore-target-accuracy`, params)
  },

  /*
  * Target Promo code
  */
  getTargetPromoCode(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `target-promo-code?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  createTargetPromoCode(params) {
    return HTTP.post(apiBaseUrl + `target-promo-code`, params);
  },
  getTargetPromoCodeDetails(params) {
    return HTTP.get(apiBaseUrl + `target-promo-code/` + params);
  },
  updateTargetPromoCode(target_promo_code_id, params) {
    return HTTP.put(apiBaseUrl + `target-promo-code/` + target_promo_code_id, params);
  },
  deleteTargetPromoCode(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `target-promo-code/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName);
  },
  getDeleteTargetPromoCode(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `deleted-target-promo-code?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  permanentTargetPromoCodeRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-target-promo-code`, params);
  },
  restoreTargetPromoCode(params) {
    return HTTP.post(apiBaseUrl + `restore-target-promo-code`, params)
  },

  /*
   * Place of service
  */
  getPlaceOfServices() {
    return HTTP.get(apiBaseUrl + `place-of-service`);
  },
  getPlaceOfServiceDetails(params) {
    return HTTP.get(apiBaseUrl + `place-of-service/` + params);
  },

  /*
  * School
  */
  getSchools(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `school?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getActiveSchool(params) {
    return HTTP.get(apiBaseUrl + `school-list`, params)
  },
  createSchool(params) {
    return HTTP.post(apiBaseUrl + `school`, params)
  },
  deleteSchool(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `school/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  getSchoolDetails(params) {
    return HTTP.get(apiBaseUrl + `school/` + params)
  },
  updateSchool(school_id, params) {
    return HTTP.post(apiBaseUrl + `school-update/` + school_id, params)
  },
  getAllSchoolList() {
    return HTTP.get(apiBaseUrl + `schools-list`)
  },
  restoreSchool(params) {
    return HTTP.post(apiBaseUrl + `restore-school`, params)
  },
  checkStaffAssign(params) {
    return HTTP.post(apiBaseUrl + `student-staff-check`, params)
  },
  permanentSchoolRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-school`, params)
  },
  getDeleteSchool(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `deleted-school?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },

  // getSchoolHolidaysList(params,data={},sort = {}) {
  getSchoolHolidaysList(school_id) {
    let url = apiBaseUrl + `school-holiday/${school_id}`
    // let url = apiBaseUrl+`school-holiday/${params.school_id}?`;

    // if(!_.isEmpty(params)) {
    //   url = url+`page=`+params.page+`&per_page=`+params.per_page;
    // }

    // if(!_.isEmpty(data)) {
    //   url = url+`&search=`+data.search;
    // }

    // if(!_.isEmpty(sort)) {
    //   url = url+`&sort_by=`+sort.sort_by+`&sort_field_name=`+sort.sort_field_name;
    // }

    return HTTP.get(url);
  },
  addUpdateSchoolHoliday(params) {
    return HTTP.post(apiBaseUrl + `school-holiday`, params)
  },

  /*
  * Coverage types
  */
  getCoveragetypes(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `coverage-types?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  createCoveragetypes(params) {
    return HTTP.post(apiBaseUrl + `coverage-types`, params)
  },
  deleteCoveragetypes(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `coverage-types/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  getCoveragetypesDetails(params) {
    return HTTP.get(apiBaseUrl + `coverage-types/` + params)
  },
  updateCoveragetypes(coverage_type_id, params) {
    return HTTP.post(apiBaseUrl + `coverage-types-update/` + coverage_type_id, params)
  },
  restoreCoveragetypes(params) {
    return HTTP.post(apiBaseUrl + `restore-coverage-types`, params)
  },
  permanentCoveragetypesRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-coverage-types`, params)
  },
  getDeleteCoveragetypes(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `deleted-coverage-types?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },

  /*
  * Reinforcement
  */
  getReinforcement(params) {
    return HTTP.get(apiBaseUrl + `reinforcement`, params)
  },
  getReinforcementSubCategory(parent_id, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `reinforcement-sub-category/` + parent_id + `?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getReinforcementParentCategory(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `reinforcement-parent-category?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getReinforcementDetails(params) {
    return HTTP.get(apiBaseUrl + `reinforcement/` + params)
  },
  deleteReinforcement(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `reinforcement/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  createReinforcement(params) {
    return HTTP.post(apiBaseUrl + `reinforcement`, params);
  },
  updateReinforcement(cid, params) {
    return HTTP.put(apiBaseUrl + `reinforcement/` + cid, params)
  },
  restoreReinforcement(params) {
    return HTTP.post(apiBaseUrl + `restore-reinforcement`, params)
  },
  permanentReinforcementRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-reinforcement`, params)
  },
  getDeleteReinforcement(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `deleted-reinforcement?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getSesionReinforcement() {
    return HTTP.get(apiBaseUrl + `session-reinforcement`);
  },

  /*
  * Group Template session
  */
  getGroupTemplateLession(params) {
    return HTTP.get(apiBaseUrl + `group-template-lession`, params)
  },
  getGroupTemplateLessionSubCategory(parent_id, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `group-template-lession-sub-category/` + parent_id + `?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getGroupTemplateLessionParentCategory(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `group-template-lession-parent-category?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getGroupTemplateLessionDetails(params) {
    return HTTP.get(apiBaseUrl + `group-template-lession/` + params)
  },
  deleteGroupTemplateLession(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `group-template-lession/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  createGroupTemplateLession(params) {
    return HTTP.post(apiBaseUrl + `group-template-lession`, params);
  },
  updateGroupTemplateLession(cid, params) {
    return HTTP.put(apiBaseUrl + `group-template-lession/` + cid, params)
  },
  restoreGroupTemplateLession(params) {
    return HTTP.post(apiBaseUrl + `restore-group-template-lession`, params)
  },
  permanentGroupTemplateLessionRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-group-template-lession`, params)
  },
  getDeleteGroupTemplateLession(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `deleted-group-template-lession?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getSesionGroupTemplateLession() {
    return HTTP.get(apiBaseUrl + `session-group-template-lession`);
  },

  /*
  * Prompt Code
  */
  getPromptCode(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `prompt-codes?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getPromptCodeDetails(params) {
    return HTTP.get(apiBaseUrl + `prompt-codes/` + params)
  },
  deletePromptCode(params) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `prompt-codes/` + params + `?redirect_to=` + window.location.origin + `/delete-` + pathName)
  },
  createPromptCode(params) {
    return HTTP.post(apiBaseUrl + `prompt-codes`, params);
  },
  updatePromptCode(cid, params) {
    return HTTP.put(apiBaseUrl + `prompt-codes/` + cid, params)
  },
  restorePromptCode(params) {
    return HTTP.post(apiBaseUrl + `restore-prompt-codes`, params)
  },
  permanentPromptCodeRemove(params) {
    return HTTP.post(apiBaseUrl + `permanent-delete-prompt-codes`, params)
  },
  getDeletePromptCode() {
    return HTTP.get(apiBaseUrl + `deleted-prompt-codes`);
  },

  /*
  * Prompt Code
  */
  getPayerPromptCode(payer_id) {
    return HTTP.get(apiBaseUrl + `payer-all-prompt-code/` + payer_id);
  },
  updatePayerPromptCode(params) {
    return HTTP.post(apiBaseUrl + `payer-prompt-code`, params);
  },

  /*
  * Invoice
  */
  getInvoice(params) {
    return HTTP.post(apiBaseUrl + `invoice-pdf`, params);
  },
  getAbaInvoice(params) {
    return HTTP.post(apiBaseUrl + `invoice-pdf-aba`, params);
  },
  getSetssInvoice(params) {
    return HTTP.post(apiBaseUrl + `invoice-pdf-setss`, params);
  },

  /*
  * Auto Generate Session Notes
  */
  autoGenerateSessionNotes(params) {
    return HTTP.post(apiBaseUrl + `auto-generate-session-notes`, params);
  },
  autoGenerateDataExport(params) {
    return HTTP.post(apiBaseUrl + `auto-generate-session-notes-export`, params);
  },
  autoGenerateDataImport(params) {
    return HTTP.post(apiBaseUrl + `auto-generate-session-notes-import`, params);
  },
  autoGenerateSessionQueues(params) {

    let url = apiBaseUrl + `session-form-template-report-queues?`;

    if (params.page && params.perPage) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage + `&student=` + params.student + `&generated_by=` + params.generated_by + `&status=` + params.status + `&session_month_year=` + params.session_month_year + `&report_id=` + params.report_id;
    }

    return HTTP.get(url);
  },
  medicalRecordsList(params) {

    let url = apiBaseUrl + `medical-records?`;

    if (params.page && params.per_page) {
      url = url + `page=` + params.page + `&per_page=` + params.per_page + `&student_id=` + params.student_id + `&funder_id=` + params.funder_id + `&status=` + params.status + `&year-month=` + params['year-month'] + `&report_id=` + params.report_id;
    }

    return HTTP.get(url);
  },
  autoGenerateSessionMergedReports(params) {

    let url = apiBaseUrl + `session-form-template-merged-reports?`;

    if (params.page && params.perPage) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    return HTTP.get(url);
  },
  mergeSessionsReports(params) {
    return HTTP.post(apiBaseUrl + `merge-session-form-template-reports`, params);
  },

  getFaxRecipients(params) {
    return HTTP.get(apiBaseUrl + `fax-recipients`, params);
  },
  createFaxRecipients(params) {
    return HTTP.post(apiBaseUrl + `fax-recipients`, params);
  },
  editFaxRecipients(id) {
    return HTTP.get(apiBaseUrl + `fax-recipients/` + id);
  },
  updateFaxRecipients(id, params) {
    return HTTP.put(apiBaseUrl + `fax-recipients/` + id, params);
  },
  updateDefaultFaxRecipients(id) {
    return HTTP.get(apiBaseUrl + `default-fax-recipients/` + id);
  },
  deleteFaxRecipients(id) {
    return HTTP.delete(apiBaseUrl + `delete-fax-recipients/` + id);
  },
  sendFax(params) {
    return HTTP.post(apiBaseUrl + `send-fax`, params);
  },
  getSentFaxList(params) {

    let url = apiBaseUrl + `sent-fax-list?`;

    if (params.page && params.perPage) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    return HTTP.get(url);
  },
  deleteFax(faxId) {
    return HTTP.delete(apiBaseUrl + `delete-fax/` + faxId);
  },
  cancelFax(faxId) {
    return HTTP.delete(apiBaseUrl + `cancel-fax/` + faxId);
  },
  downloadFax(faxId) {
    return HTTP.get(apiBaseUrl + `fax-download/` + faxId);
  },
  faxSessionReport(jobId) {
    return HTTP.get(apiBaseUrl + `fax-session-report/` + jobId);
  },
  billingKareoDataImport(params) {
    return HTTP.post(apiBaseUrl + `billing-kareo-data-import`, params);
  },
  gets3Url(params) {
    return HTTP.post(apiBaseUrl + `generate-s3-url`, params);
  },
  generateTempUrl(params){
    return HTTP.post(apiBaseUrl + `medical-records/generate-temp-url`, params);
  },
  regenerateSession(params) {
    return HTTP.post(apiBaseUrl + `regenerate-session`, params);
  },
  regenerateMedicalRecord(params) {
    return HTTP.post(apiBaseUrl + `medical-records/regenerate`, params);
  },
  deleteSession(id) {
    return HTTP.delete(apiBaseUrl + `session-form-template-report-queues/${id}`);
  },
  deleteMedicalRecord(id) {
    return HTTP.delete(apiBaseUrl + `medical-records/${id}`);
  },
  deleteMergedSession(id) {
    return HTTP.delete(apiBaseUrl + `session-form-template-merged-reports/${id}`);
  },
  autoGenerateSessionNotesCount() {
    return HTTP.get(apiBaseUrl + `kareo-import/check-import-status`);
  },
  getKareoImportDataList(params) {
    return HTTP.get(apiBaseUrl + `get-kareo-import-list`, params);
  },
  getPendingDataList(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `session-form-template-pending?page=` + params.page + `&per_page=` + params.perPage;

    if (!_.isEmpty(data)) {
      url = url + `&studentId=` + data.studentId + `&startDate=` + data.startDate + `&endDate=` + data.endDate;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  sessionFromTemplateSignatureCheck(params) {
    return HTTP.post(apiBaseUrl + `session-form-template-report-signature-check`, params);
  },
  filterKareoImportData(data = {}) {
    let url = apiBaseUrl + `filter-kareo-import-list`;

    // let payLoad = data;
    // if(!_.isEmpty(params)) {
    //   //  url = url+`page=`+params.page+`&per_page=`+params.perPage;
    //   let obj = {page: params.page, per_page: params.perPage}
    //   payLoad = {...payLoad, ...obj}
    // }

    // if(!_.isEmpty(data)) {
    //   // url = url+`&post_date=`+data.post_date+`&session_date=`+data.session_date+`&import_date=`+data.import_date+`&patient_id=`+data.patient_id+`&patient_name=`+data.patient_name+`&code=`+data.code+`&rend_provider=`+data.rend_provider+`&location=`+data.location+`&units=`+data.units+`&units_charges=`+data.units_charges+`&total_charges=`+data.total_charges+`&status=`+data.status;
    //   // url = url + '&' + { data };
    //   url = url + `&post_date=`+data.post_date + `&post_end_date=`+data.post_end_date + `&session_date=`+data.session_date + `&session_end_date=`+data.session_end_date + `&patient_id=`+data.patient_id+`&patient_name=`+data.patient_name+`&code=`+data.code+`&rend_provider=`+data.rend_provider+`&location=`+data.location+`&units=`+data.units+`&units_charges=`+data.units_charges+`&total_charges=`+data.total_charges+`&import_date=`+data.import_date+`&status=`+data.status+`&encounter_charges=`+data.encounter_charges+`&adjustment=`+data.adjustment+`&receipts=`+data.receipts+`&balance=`+data.balance+`&first_bill_dt=`+data.first_bill_dt+`&last_bill_dt=`+ data.last_bill_dt+`&secondary_insurance_first_bill_date=`+data.secondary_insurance_first_bill_date+`&secondary_insurance_last_bill_date=`+data.secondary_insurance_last_bill_date+`&patient_first_bill_date=` +data.patient_first_bill_date+`&patient_last_bill_date=`+data.patient_last_bill_date+`&payment_posting_date=`+data.payment_posting_date+`&secondary_insurance_payment_posting_date=`+ data.secondary_insurance_payment_posting_date+`&tertiary_insurance_payment_posting_date=`+data.tertiary_insurance_payment_posting_date+`&patient_payment_posting_date=`+data.patient_payment_posting_date+`&last_payment_date=`+data.last_payment_date+`&patient_date_of_birth=`+data.patient_date_of_birth+`&service_location_name=`+data.service_location_name+`&final_location=`+ data.final_location+`&case_payer_scenario=`+data.case_payer_scenario+`&scheduling_provider_name=`+data.scheduling_provider_name+`&procedure_modifier_1=`+data.procedure_modifier_1+`&primary_insurance_company_name=`+data.primary_insurance_company_name+`&primary_insurance_plan_name=`+data.primary_insurance_plan_name+`&as_sheet_status=`+data.as_sheet_status+`&service_location_billing_name=`+data.service_location_billing_name+`&service_location_place_of_service_name=`+data.service_location_place_of_service_name+`&service_location_npi=`+data.service_location_npi+`&other_adjustment=`+data.other_adjustment+`&last_week_adjustment=`+data.last_week_adjustment+`&last_week_receipts=`+data.last_week_receipts+`&rvu=`+data.rvu+`&validation=`+data.validation+`&line_number=`+data.line_number;
    //   // console.log(url);
    // }

    // if(!_.isEmpty(sort)) {
    //   // url = url+`&sort_by=`+sort.sort_by+`&sort_field_name=`+sort.sort_field_name;

    //   payLoad = {...payLoad, ...sort}
    // }

    return HTTP.post(url, data);
  },
  getFilteredResultData(data) {
    let url = apiBaseUrl + `kareo-export`;

    // if(!_.isEmpty(data)) {
    //   url = url+`&post_date=`+data.post_date + `&post_end_date=`+data.post_end_date + `&session_date=`+data.session_date + `&session_end_date=`+data.session_end_date + `&patient_id=`+data.patient_id+`&patient_name=`+data.patient_name+`&code=`+data.code+`&rend_provider=`+data.rend_provider+`&location=`+data.location+`&units=`+data.units+`&units_charges=`+data.units_charges+`&total_charges=`+data.total_charges+`&import_date=`+data.import_date+`&status=`+data.status+`&encounter_charges=`+data.encounter_charges+`&adjustment=`+data.adjustment+`&receipts=`+data.receipts+`&balance=`+data.balance+`&first_bill_dt=`+data.first_bill_dt+`&last_bill_dt=`+ data.last_bill_dt+`&secondary_insurance_first_bill_date=`+data.secondary_insurance_first_bill_date+`&secondary_insurance_last_bill_date=`+data.secondary_insurance_last_bill_date+`&patient_first_bill_date=` +data.patient_first_bill_date+`&patient_last_bill_date=`+data.patient_last_bill_date+`&payment_posting_date=`+data.payment_posting_date+`&secondary_insurance_payment_posting_date=`+ data.secondary_insurance_payment_posting_date+`&tertiary_insurance_payment_posting_date=`+data.tertiary_insurance_payment_posting_date+`&patient_payment_posting_date=`+data.patient_payment_posting_date+`&last_payment_date=`+data.last_payment_date+`&patient_date_of_birth=`+data.patient_date_of_birth+`&service_location_name=`+data.service_location_name+`&final_location=`+ data.final_location+`&case_payer_scenario=`+data.case_payer_scenario+`&scheduling_provider_name=`+data.scheduling_provider_name+`&procedure_modifier_1=`+data.procedure_modifier_1+`&primary_insurance_company_name=`+data.primary_insurance_company_name+`&primary_insurance_plan_name=`+data.primary_insurance_plan_name+`&as_sheet_status=`+data.as_sheet_status+`&service_location_billing_name=`+data.service_location_billing_name+`&service_location_place_of_service_name=`+data.service_location_place_of_service_name+`&service_location_npi=`+data.service_location_npi+`&other_adjustment=`+data.other_adjustment+`&last_week_adjustment=`+data.last_week_adjustment+`&last_week_receipts=`+data.last_week_receipts+`&rvu=`+data.rvu+`&validation=`+data.validation+`&line_number=`+data.line_number+`&send_email=`+data.send_email;
    // }

    return HTTP.post(url, data);
  },
  getFilterAttributeList(params = {}) {
    let url = '';
    if (_.isEmpty(params)) {
      url = `kareo-import-dropdown_filter`;
    } else {
      url = `kareo-import-dropdown_filter?` + params;
    }
    return HTTP.get(apiBaseUrl + url);
  },

  /*
  * Session Reports
  */
  getSessionReports(params, data = {}, sort = {}) {

    let url = apiBaseUrl + `session-report?page=` + params.page + `&per_page=` + params.perPage;

    if (!_.isEmpty(data)) {
      url = url + `&student_id=` + data.student_id + `&month_year=` + data.month_year + `&session_start_date=` + data.session_start_date + `&session_end_date=` + data.session_end_date + `&hcode=` + data.hcode;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  /*
  Import Staffstudent-import
  */
  // saveStaffFile(params){
  //   return HTTP.post(apiBaseUrl+`staff-import`, params)
  // },
  /*
  Import students
  */
  saveStudentFile(params, options) {
    return HTTP.post(apiBaseUrl + `student-import`, params, options || {})
  },
  /*
  Import student Auth Data
  */
  // saveStudentAuthFile(params){
  //   return HTTP.post(apiBaseUrl+`student-auth-utilization-rethink-import`, params)
  // },
  /*
  student Invoice Sheet Import Data...
  */
  invoiceSheetImportList(params) {
    return HTTP.post(apiBaseUrl + `invoice-sheet-import`, params)
  },
  filterInvoiceSheetImportList(params) {
    return HTTP.post(apiBaseUrl + `filter-invoice-sheet-import`, params);
  },
  /*
  Invoice Import
  */
  filterInvoiceData(params) {
    return HTTP.post(apiBaseUrl + `invoice-import-list`, params)
  },
  getInvoiceDataImport(params) {
    return HTTP.post(apiBaseUrl + `invoice-import-list`, params)
  },
  getBlankInvoiceImportData(params) {
    return HTTP.post(apiBaseUrl + `blank-invoice-list`, params);
  },
  getDoeInvoiceImportData(params) {
    return HTTP.post(apiBaseUrl + `doe-invoice-list`, params);
  },
  getAbaInvoiceImportData(params) {
    return HTTP.post(apiBaseUrl + `aba-invoice-list`, params);
  },
  InvoiceSheetDataImport(params) {
    return HTTP.post(apiBaseUrl + `invoice-data-import`, params);
  },
  exportTabBasedInvoice(params) {
    return HTTP.post(apiBaseUrl + `export-tab-based-invoice`, params);
  },
  //invoice-doe-import
  doeImportInvoice(params) {
    return HTTP.post(apiBaseUrl + `invoice-doe-import`, params);
  },
  abaImportInvoice(params) {
    return HTTP.post(apiBaseUrl + `invoice-aba-import`, params);
  },
  /*
  * Staff Payroll
  */
  getStaffPayroll(user_id, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `staff-payroll/` + user_id + '?';

    if (!_.isEmpty(params)) {
      url = url + `&page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  postStaffPayroll(params) {
    return HTTP.post(apiBaseUrl + `staff-payroll`, params);
  },
  getStaffPayrollData(id, params) {
    return HTTP.post(apiBaseUrl + `get-staff-payroll/` + id, params);
  },

  /* Modified all New API*/
  getPayerList(val) {
    return HTTP.get(apiBaseUrl + `list_payer?search=` + val);
  },
  getServiceLineList(val) {
    return HTTP.get(apiBaseUrl + `list_serviceline?search=` + val);
  },
  getServiceLineListForSelect() {
    return HTTP.get(apiBaseUrl + `list_serviceline`);
  },
  getService(val) {
    return HTTP.get(apiBaseUrl + `list_service?search=` + val);
  },
  getDynamicSessionTemplateServices(){
    return HTTP.get(apiBaseUrl + `dynamic-session-template/services/get`);
  },
  getFouders(val) {
    return HTTP.get(apiBaseUrl + `all-payers?search=` + val);
  },
  getClientLists(val) {
    return HTTP.get(apiBaseUrl + `client-list?search=` + val);
  },
  getTemplateClientLists(val) {
    return HTTP.get(apiBaseUrl + `template-client-list?search=` + val);
  },
  getCertifationLists(val) {
    return HTTP.get(apiBaseUrl + `certifications?search=` + val);
  },
  getAllCertifations(val) {
    return HTTP.get(apiBaseUrl + `all-certifications?search=` + val);
  },
  getCertificationsAll(val) {
    return HTTP.get(apiBaseUrl + `certifications-all?search=` + val);
  },
  getAllPromptCode(val) {
    let url = apiBaseUrl + `all-prompt-codes?`;

    return HTTP.get(url);
  },
  getUserTypeLists(type, val = "", studentId = "") {
    return HTTP.get(apiBaseUrl + `user/typeAll/` + type + `?search=` + val + `&student_id=` + studentId);
  },
  getUserGroupLists() {
    return HTTP.get(apiBaseUrl + `user-group-parent`);
  },
  getBillingCodeList(payerId) {
    return HTTP.get(apiBaseUrl + `payer/billingcodeall/` + payerId);
  },
  getAllCovarageTypes(val) {
    return HTTP.get(apiBaseUrl + `all-coverage-types?search=` + val);
  },
  getAllGoals(val) {
    return HTTP.get(apiBaseUrl + `all-goals?search=` + val);
  },
  getAllUsersByType(userType, data) {
    let url = apiBaseUrl + `user/typeAll/` + userType + `?`;

    if (!_.isEmpty(data)) {
      url = url + `search=` + data;
    }

    return HTTP.get(url);
  },
  getAllPayerBillingCode(payer_id, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `payer/billingcodeall/` + payer_id + '?';

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getAllUserGroup(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `all-user-groups?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getAllSkillArea(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `skill-area-list?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getChildAllCategories(parent_id, student_id, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `paginte-program/sub-category/` + parent_id + `/` + student_id;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getAllBehaviorCategory(params) {
    let url = apiBaseUrl + `all-behavior-category?search=` + params;

    return HTTP.get(url);
  },
  getSkillAreaList(params) {
    let url = apiBaseUrl + `skill-area-list?search=` + params;

    return HTTP.get(url);
  },
  getAllBehavior(params, type = '') {
    let url = apiBaseUrl + `all-behaviors?type=${type}&search=` + params;

    return HTTP.get(url);
  },
  getStudentAllPromptcode(student_id, params) {
    let url = apiBaseUrl + `all-student-promptcodes/` + student_id + `?search=` + params;

    return HTTP.get(url);
  },
  getCallendarServices(params) {
    let url = apiBaseUrl + `get-services-by-ids`;

    return HTTP.post(url, params);
  },
  getSchoolList() {
    return HTTP.get(apiBaseUrl + `schools-list`);
  },
  getFilteredServiceLinePlaces(params) {
    // console.log(params);
    let url = ''
    if (params.service_line && params.service_line != '') {
      if (params.services && params.services != '') {
        url = apiBaseUrl + `get-serviceline-places?service-line=${params.service_line}&&services=${params.services}`;
      } else {
        url = apiBaseUrl + `get-serviceline-places?service-line=` + params.service_line;
      }
    }
    return HTTP.get(url);
  },

  getFilteredGoals(params) {
    let queryParams = new URLSearchParams();

    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });

    let url = `${apiBaseUrl}graph/filter?${queryParams.toString()}`;

    return HTTP.get(url);
  },

  // Graph API
  getabcBehaviorGraph(student_id, date_from, date_to, val) {
    return HTTP.get(apiBaseUrl + `graph/student-behavior-graph-abc?student_id=` + student_id + `&date_from=` + date_from + `&date_to=` + date_to + `&intensity=` + val.intensity)
  },
  getStudentsBehaviorGraph(student_id, date_from, date_to, val) {
    return HTTP.get(apiBaseUrl + `graph/student-behavior-graph?student_id=` + student_id + `&date_from=` + date_from + `&date_to=` + date_to + `&behaviorType=` + val.behaviorType + `&category=` + val.category + `&type=` + val.type)
  },
  getStudentSkillBehaviorGraph(student_id, date_from, date_to, obj) {
    return HTTP.get(apiBaseUrl + `graph/student-skill-graph?student_id=` + student_id + `&date_from=` + date_from + `&date_to=` + date_to + `&studentSkillType=` + obj.type + `&category=` + obj.cat + `&graphType=` + obj.graphType + `&isMaxValSelected=` + obj.isMaxValSelected + `&recordingType=` + obj.recordingType)
  },
  getCategoryTypeGraphValue(student_id, recordingType) {
    return HTTP.get(apiBaseUrl + `graph/filter?student_id=` + student_id + `&recordingType=` + recordingType)
  },
  importGraphData(params) {
    // return HTTP.post(apiBaseUrl+`graph/skill-data-import`, params);

    return HTTP.post(apiBaseUrl + `graph/import-behaviour-graph`, params);
  },
  getStudentTechnicalIndicatorsGraph(student_id, date_from, date_to, type, cat, technical_indicator, isMaxValSelected, recordingType) {
    return HTTP.get(apiBaseUrl + `graph/skill-technical-indicators?student_id=` + student_id + `&date_from=` + date_from + `&date_to=` + date_to + `&studentSkillType=` + type + `&category=` + cat + `&technical_indicator=` + technical_indicator + `&isMaxValSelected=` + isMaxValSelected + `&recordingType=` + recordingType)
  },
  getGraphDataImportList(params, data = {}, sort = {}) {
    // return HTTP.get(apiBaseUrl + `goal-attribute-list`);

    let url = apiBaseUrl + `graph/import-behaviour-graph-list?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search + `&start_date=` + data.start_date + `&end_date=` + data.end_date + `&session_start_date=` + data.session_start_date + `&session_end_date=` + data.session_end_date + `&category=` + data.category + `&student=` + data.student_id + `&PlayList=` + data.playList + `&status=` + data.status;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getNoteHelperGraph(params) {
    return HTTP.post(apiBaseUrl + `student-program-graph`, params)
  },
  getNoteHelperUpdateGraph(params) {
    return HTTP.post(apiBaseUrl + `student-program-progress`, params)
  },
  getNoteHelperGraphData(params) {
    return HTTP.post(apiBaseUrl + `student-program-progress-view`, params)
  },
  deleteNoteHelperGraphData(id) {
    return HTTP.delete(apiBaseUrl + `student-program-progress/` + id)
  },

  // Goal Attribute or Goal Activity
  getGoalAttributeList(params, data = {}, sort = {}) {
    // return HTTP.get(apiBaseUrl + `goal-attribute-list`);

    let url = apiBaseUrl + `goal-attribute-list?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getGoalAttribute(goal_attribute_id) {
    return HTTP.get(apiBaseUrl + `goal-attribute-show/` + goal_attribute_id);
  },
  getDeletedGoalAttributeList(params, data = {}, sort = {}) {
    // return HTTP.get(apiBaseUrl + `goal-attribute-delete-list`);
    let url = apiBaseUrl + `goal-attribute-delete-list?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getGoalAttributeFormDropdowns() {
    return HTTP.get(apiBaseUrl + `goal-attribute-dropdown-list`);
  },
  getDynamicSessionTemplateSkillAreaList(){
    return HTTP.get(apiBaseUrl + `dynamic-session-template/skill-area/get`);
  },
  addGoalAttribute(params) {
    return HTTP.post(apiBaseUrl + `goal-attribute-add`, params);
  },
  updateGoalAttribute(params, goal_attribute_id) {
    return HTTP.post(apiBaseUrl + `goal-attribute-update/` + goal_attribute_id, params);
  },
  softDeleteGoalAttribute(params) {
    return HTTP.post(apiBaseUrl + `goal-attribute-delete`, params);
  },
  restoreGoalAttribute(params) {
    return HTTP.post(apiBaseUrl + `goal-attribute-restore`, params);
  },
  permanentDeleteGoalAttribute(params) {
    return HTTP.post(apiBaseUrl + `goal-attribute-permanet-delete`, params);
  },
  deleteMassGoalData(param) {
    return HTTP.post(apiBaseUrl + `mass-goal-delete`, param);
  },
  importSampleDocInExclToDoc(param) {
    return HTTP.post(apiBaseUrl + `sample-doc-in-excl-to-doc`, param);
  },
  importSampleExclInExclToDoc(param) {
    return HTTP.post(apiBaseUrl + `sample-excl-in-excl-to-doc`, param);
  },
  importSampleDocInDocToExcl(param) {
    return HTTP.post(apiBaseUrl + `sample-doc-in-doc-to-excl`, param);
  },
  getDemoexampleFiles(params) {
    return HTTP.post(apiBaseUrl + `get-configs`, params);
  },
  createEnrollment(params){
    return HTTP.post(apiBaseUrl + `eligibility/enrolment/create`, params);
  },
  checkEnrollment(id){
    return HTTP.get(apiBaseUrl + `eligibility/enrolment/check/`+ id);
  },
  resendEnrollment(id){
    return HTTP.get(apiBaseUrl + `eligibility/enrolment/resend/`+ id);
  },
  enrolments(params = {}, filters = {}, sort = {}) {
    let url = apiBaseUrl + `eligibility/enrolment?`;

    if (!_.isEmpty(params)) {
      url += `page=${params.page}&per_page=${params.per_page}`;
    }

    if (!_.isEmpty(filters)) {
      Object.keys(filters).forEach(key => {
        const value = filters[key];

        if (value !== '' && value !== null) {
          if (Array.isArray(value)) {
            // Send multiple values as key[]=val1&key[]=val2
            value.forEach(v => {
              url += `&${encodeURIComponent(key)}[]=${encodeURIComponent(v)}`;
            });
          } else {
            url += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
          }
        }
      });
    }

    if (!_.isEmpty(sort)) {
      url += `&sort_by=${sort.sort_by}&sort_field_name=${sort.sort_field_name}`;
    }

    return HTTP.get(url);
  },
  letaConstantsServiceTypes(params = {}, filters = {}, sort = {}) {
    let url = apiBaseUrl + `eligibility/leta-constants/service-types?`;



    if (!_.isEmpty(params)) {
      url += `page=${params.page}&per_page=${params.per_page}`;
    }

    if (!_.isEmpty(filters)) {
      Object.keys(filters).forEach(key => {
        const value = filters[key];

        if (value !== '' && value !== null) {
            url += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        }
      });
    }

    if (!_.isEmpty(sort)) {
      url += `&sort_by=${sort.sort_by}&sort_field_name=${sort.sort_field_name}`;
    }
    return HTTP.get(url);
  },
  assignServiceList(params){
    return HTTP.post(apiBaseUrl + `eligibility/leta-constants/service-types/assign-service-line`, params);
  },
  removeServiceLine(id){
    return HTTP.get(apiBaseUrl + `eligibility/leta-constants/service-types/remove-service-line/`+ id);
  },

  // New Eligibility APIs (service types list and insurance verification)
  eligibilityServiceTypes() {
    return HTTP.get(apiBaseUrl + `eligibility/service-type-codes`);
  },
  requestInsuranceVerification(params) {
    return HTTP.post(apiBaseUrl + `eligibility/insurance/verify`, params);
  },
  listWaystarPayerMappings(params = {}) {
    const url = apiBaseUrl + `eligibility/waystar/payer-mappings`;
    return HTTP.get(url, { params });
  },
  listWaystarPayers(params = {}) {
    const url = apiBaseUrl + `eligibility/waystar/payers`;
    return HTTP.get(url, { params });
  },
  saveWaystarPayerMapping(params) {
    const url = apiBaseUrl + `eligibility/waystar/payer-mappings`;
    return HTTP.post(url, params);
  },
  letaConstantsLetaConstants(params = {}, filters = {}, sort = {}) {
    let url = apiBaseUrl + `eligibility/leta-constants/leta-payers?`;

    if (!_.isEmpty(params)) {
      url += `page=${params.page}&per_page=${params.per_page}`;
    }

    if (!_.isEmpty(filters)) {
      Object.keys(filters).forEach(key => {
        const value = filters[key];

        if (value !== '' && value !== null) {
            url += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        }
      });
    }

    if (!_.isEmpty(sort)) {
      url += `&sort_by=${sort.sort_by}&sort_field_name=${sort.sort_field_name}`;
    }
    return HTTP.get(url);
  },
  assignPayer(params){
    return HTTP.post(apiBaseUrl + `eligibility/leta-constants/leta-payers/assign-payer`, params);
  },
  removePayer(id){
    return HTTP.get(apiBaseUrl + `eligibility/leta-constants/leta-payers/remove-payer/`+ id);
  },

  enrollmentChecks(params = {}, filters = {}, sort = {}) {
    let url = apiBaseUrl + `eligibility/check?`;

    if (!_.isEmpty(params)) {
      url += `page=${params.page}&per_page=${params.per_page}`;
    }

    if (!_.isEmpty(filters)) {
      Object.keys(filters).forEach(key => {
        const value = filters[key];

        if (value !== '' && value !== null) {
          if (Array.isArray(value)) {
            // Send multiple values as key[]=val1&key[]=val2
            value.forEach(v => {
              url += `&${encodeURIComponent(key)}[]=${encodeURIComponent(v)}`;
            });
          } else {
            url += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
          }
        }
      });
    }

    if (!_.isEmpty(sort)) {
      url += `&sort_by=${sort.sort_by}&sort_field_name=${sort.sort_field_name}`;
    }
    return HTTP.get(url);
  },
  eligibilityCheckRequest(params){
    return HTTP.post(apiBaseUrl + `eligibility/check/store`, params);
  },
  eligibilityResendCheck(id){
    return HTTP.get(apiBaseUrl + `eligibility/check/resend/`+ id);
  },
  sendEligibilityCheck(id){
    return HTTP.get(apiBaseUrl + `eligibility/check/result/`+ id);
  },
  checkEligibility(id){
    return HTTP.get(apiBaseUrl + `eligibility/check/`+ id);
  },
  getBatchUploads(params = {}, filters = {}, sort = {}) {
    let url = apiBaseUrl + `eligibility/batch?`;

    if (!_.isEmpty(params)) {
      url += `page=${params.page}&per_page=${params.per_page}`;
    }

    if (!_.isEmpty(filters)) {
      Object.keys(filters).forEach(key => {
        const value = filters[key];

        if (value !== '' && value !== null) {
          if (Array.isArray(value)) {
            // Send multiple values as key[]=val1&key[]=val2
            value.forEach(v => {
              url += `&${encodeURIComponent(key)}[]=${encodeURIComponent(v)}`;
            });
          } else {
            url += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
          }
        }
      });
    }

    if (!_.isEmpty(sort)) {
      url += `&sort_by=${sort.sort_by}&sort_field_name=${sort.sort_field_name}`;
    }
    return HTTP.get(url);
  },
  getDynamicMergeFields(params = {}, filters = {}, sort = {}) {
    let url = apiBaseUrl + `dynamic-merge-field?`;

    if (!_.isEmpty(params)) {
      url += `page=${params.page}&per_page=${params.per_page}`;
    }

    if (!_.isEmpty(filters)) {
      Object.keys(filters).forEach(key => {
        const value = filters[key];

        if (value !== '' && value !== null) {
          if (Array.isArray(value)) {
            // Send multiple values as key[]=val1&key[]=val2
            value.forEach(v => {
              url += `&${encodeURIComponent(key)}[]=${encodeURIComponent(v)}`;
            });
          } else {
            url += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
          }
        }
      });
    }

    if (!_.isEmpty(sort)) {
      url += `&sort_by=${sort.sort_by}&sort_field_name=${sort.sort_field_name}`;
    }
    return HTTP.get(url);
  },
  uploadBatch(params){
    return HTTP.post(apiBaseUrl + `eligibility/batch/upload`, params);
  },

  //File Manager with Dropbox integrations.
  getFoldersList(student_id = '') {
    let url = apiBaseUrl + `get-folders-list`;
    if (student_id != '') {
      url += `?studentId=` + student_id;
    }
    return HTTP.get(url);
  },
  getAllFoldersNavigationList(parent_id = '') {
    let url = apiBaseUrl + `get-folders-list`;
    if (parent_id != '') {
      url += `?parentId=` + parent_id;
    }
    return HTTP.get(url);
  },
  getFilesAndFoldersDropbox(search) {
    console.log(search)
    let url = apiBaseUrl + `search-files?search=` + search;

    return HTTP.get(url);
  },
  getFilesAndFolders(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `get-files-folders?`;
    // console.log(params);

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }
    if (!_.isEmpty(params) && params.student_id && params.student_id != '') {
      url += `&studentId=` + params.student_id
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.i)

      if (!_.isEmpty(sort)) {
        url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
      }

    return HTTP.get(url);
    // return HTTP.get(apiBaseUrl + `get-files-folders`);
  },

  getFilesAndFoldersDropboxLatest(params = {}, data = {}, sort = {}) {
    let url = apiBaseUrl + `dropbox-item?`;

    if (params.page && params.perPage) {
      url += `page=${params.page}&per_page=${params.perPage}`;
    }

    if (params.student_id) {
      url += `&student_id=${params.student_id}`;
    }

    if (params.folder_id) {
      url += `&folder_id=${params.folder_id}`;
    }

    if (data.search && data.search != '') {
      url += `&search=${data.search}`;
    }

    if (sort.sort_by && sort.sort_field_name) {
      url += `&sort_by=${sort.sort_by}&sort_field_name=${sort.sort_field_name}`;
    }

    return HTTP.get(url);
  },
  getFolderDetails(id) {
    let url = apiBaseUrl + `show-folder-details/${id}`;
    return HTTP.get(url);
  },
  getFileDetails(id) {
    return HTTP.get(apiBaseUrl + `get-file-details/${id}`);
  },
  getFolderContents(id) {
    // getFolderContents(id, params, data = {}, sort = {}) {
    // let url = apiBaseUrl + get-folder-data/${id}?`;

    // if (!_.isEmpty(params)) {
    //   url = url + `page=` + params.page + `&per_page=` + params.perPage;
    // }

    // if (!_.isEmpty(data)) {
    //   url = url + `&search=` + data.search;
    // }

    // if (!_.isEmpty(sort)) {
    //   url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    // }

    // return HTTP.get(url);
    return HTTP.get(apiBaseUrl + `get-folder-data/${id}`);
  },
  getDeletedFoldersList(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `deleted-folder-list?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.per_page;
    }

    if (!_.isEmpty(params) && params.student_id && params.student_id != '') {
      url += `&studentId=` + params.student_id
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
    // return HTTP.get(apiBaseUrl + `deleted-folder-list`);
  },
  getDeletedFileList(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `deleted-file-list?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.per_page;
    }

    if (!_.isEmpty(params) && params.student_id && params.student_id != '') {
      url += `&studentId=` + params.student_id
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
    // return HTTP.get(apiBaseUrl + `deleted-file-list`);
  },
  getSharedFolders(params, data = {}, sort = {}) {

    let url = apiBaseUrl + `shared-folder-list?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.per_page;
    }

    if (!_.isEmpty(params) && params.student_id && params.student_id != '') {
      url += `&studentId=` + params.student_id
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
    // return HTTP.get(apiBaseUrl + `shared-folder-list`);SS
  },
  getSharedFiles(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `shared-file-list?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.per_page;
    }

    if (!_.isEmpty(params) && params.student_id && params.student_id != '') {
      url += `&studentId=` + params.student_id
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
    // return HTTP.get(apiBaseUrl + `shared-file-list`);
  },
  folderCreate(params) {
    return HTTP.post(apiBaseUrl + `create-folder`, params);
  },
  folderUpdate(id, params) {
    return HTTP.post(apiBaseUrl + `update-folder/${id}`, params);
  },
  uploadFile(params) {
    return HTTP.post(apiBaseUrl + `file-upload`, params);
  },
  fileUpdate(id, params) {
    return HTTP.post(apiBaseUrl + `update-file-upload/${id}`, params);
  },
  deleteFolder(id) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `delete-folder/${id}?redirect_to=${window.location.origin}/${pathName}`);
  },
  deleteFile(id) {
    let pathName = window.location.pathname.replace('/', '');
    return HTTP.delete(apiBaseUrl + `delete-file/${id}`);
  },
  permanentDeleteFolder(params) {
    return HTTP.post(apiBaseUrl + `folder-permanent-delete`, params)
  },
  deleteMultipleFolders(folderIds) {
    return HTTP.delete(apiBaseUrl + `delete-multiple-folders?folderId=` + folderIds);
  },
  deleteMultipleFiles(fileIds) {
    return HTTP.delete(apiBaseUrl + `delete-multiple-files?fileId=` + fileIds);
  },
  restoreDeletedFolder(params) {
    return HTTP.post(apiBaseUrl + `restore-deleted-folder`, params);
  },
  restoreDeletedFile(params) {
    return HTTP.post(apiBaseUrl + `restore-deleted-file`, params);
  },
  permanentDeleteFile(params) {
    return HTTP.post(apiBaseUrl + `file-permanent-delete`, params);
  },
  downloadFolderZip(ids) {
    return HTTP.get(apiBaseUrl + `download-zipped-folders?folder_ids=${ids}`);
  },
  downloadMultipleFiles(ids) {
    return HTTP.get(apiBaseUrl + `download-files?file_ids=${ids}`);
  },
  // shareFolder(id, params) {
  //   return HTTP.post(apiBaseUrl + `share-folder/${id}`,params);
  // },
  // shareFile(id,params) {
  //   return HTTP.post(apiBaseUrl + `share-file/${id}`,params);
  // },
  shareMultipleFolders(params) {
    return HTTP.post(apiBaseUrl + `share-multiple-folders`, params);
  },
  shareMultipleFiles(params) {
    return HTTP.post(apiBaseUrl + `share-multiple-files`, params);
  },
  copyMultipleFolders(params) {
    return HTTP.post(apiBaseUrl + `copy-multiple-folders`, params);
  },
  copyMultipleFiles(params) {
    return HTTP.post(apiBaseUrl + `copy-multiple-files`, params);
  },
  moveMultipleFolders(params) {
    return HTTP.post(apiBaseUrl + `move-multiple-folders`, params);
  },
  moveMultipleFiles(params) {
    return HTTP.post(apiBaseUrl + `move-multiple-files`, params);
  },
  getAllUsersForDropdown(search, type = "") {
    let url = apiBaseUrl + `all-users?userType=` + type;
    if (search != '') {
      url += `&search=${search}`;
    }
    return HTTP.get(url);
  },
  // getAllUsersForDropdown() {
  //   return HTTP.get(apiBaseUrl + `all-users`);
  // },
  addActivityToGoal(param) {
    return HTTP.post(apiBaseUrl + `goal-activity-add`, param);
  },
  editActivityToGoal(param) {
    return HTTP.post(apiBaseUrl + `goal-activity-update`, param);
  },
  deleteActivityToGoal(param) {
    return HTTP.post(apiBaseUrl + `goal-activity-delete`, param);
  },
  getGoalActivitySession(params) {
    return HTTP.get(apiBaseUrl + `goal-activity-sessions-list?search=` + params)
  },
  getGoalActivityDescription(params) {
    return HTTP.get(apiBaseUrl + `goal-activity-descriptions-list?search=` + params)
  },
  getGoalActivitySkillAreas(params) {
    return HTTP.get(apiBaseUrl + `goal-activity-skill-areas-list?search=` + params)
  },
  getGoalTargetNames(params) {
    return HTTP.get(apiBaseUrl + `goal-target-names-list?search=` + params)
  },
  updateMassGoalImport(params) {
    return HTTP.post(apiBaseUrl + `update-goal`, params);
  },
  showMassGoalImport(id) {
    return HTTP.get(apiBaseUrl + `show-goal/${id}`);
  },
  getSheetsLink(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `as-sheet-link?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getIndivudualSheetsLink(id) {
    return HTTP.get(apiBaseUrl + `as-sheet-link/${id}`);
  },
  createSheetsLink(params) {
    return HTTP.post(apiBaseUrl + `as-sheet-link`, params);
  },
  updateSheetsLink(id, params) {
    return HTTP.patch(apiBaseUrl + `as-sheet-link/${id}`, params);
  },
  runSheetsLink(id) {
    return HTTP.get(apiBaseUrl + `as-sheet-link-run/${id}`);
  },

  // get service lines list for dropdown in Student-list filters
  getServiceLinesForDropdown(search = '') {
    let url = apiBaseUrl + `list_serviceline`;
    // console.log(search);
    return HTTP.get(url);
  },
  getServicesForDropdown(search = '') {
    let url = apiBaseUrl + `list_service`;
    // console.log(search);
    return HTTP.get(url);
  },
  getBillingCodesForDropdown(search = '') {
    let url = apiBaseUrl + `all-billing-codes`;
    // console.log(search);
    return HTTP.get(url);
  },
  previewIntakeForm(id) {
    // console.log(id);
    return HTTP.get(apiBaseUrl + `intake-form-preview/${id}`);
  },
  previewdynamicSession(id) {
    return HTTP.post(apiBaseUrl + `dynamic-session-preview/${id}`);
  },
  requestDropBoxApi() {
    return HTTP.get(apiBaseUrl + `dropbox`);
  },
  callCheckList() {
    return HTTP.get(apiBaseUrl + `goals-import-from-doc-write-excel-check-list`);
  },
  getListOfDocument(params, data = {}, sort = {}, token) {
    let url = apiBaseUrl + `get-list-of-document/` + token + `?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getDetailsDocument(token, id) {
    let url = apiBaseUrl + `get-details-of-document/` + token + `/` + id;

    return HTTP.get(url);
  },

  uploadSignedWordTemplate(params) {
    return HTTP.post(apiBaseUrl + `upload-files-for-document`, params)
  },

  getAllStafList(search, meta = true) {
    let meta_val = meta ? 1 : 0;
    let url = apiBaseUrl + `all-staffs?per_page=100&with_meta=` + meta_val;

    if (!_.isEmpty(search)) {
      url = url + `&search=` + search;
    }

    return HTTP.get(url);
  },
  getExlDocList(params = {}, data = undefined, sort = undefined) {
    const isSortObj = o => o && typeof o === "object" && ("sort_by" in o || "sort_field_name" in o);
    const isDataObj = o => o && typeof o === "object" && !isSortObj(o);

    const finalParams = { ...params, ...(isDataObj(data) ? data : {}) };

    const finalSort = isSortObj(sort) ? sort : (isSortObj(data) ? data : {});

    const query = {
      page: finalParams.page || 1,
      per_page: finalParams.per_page || finalParams.perPage || 50,
    };

    const optionalKeys = [
      "student_id",
      "search",
      "funder_id",
      "staff_id",
      "start_date_of_auth",
      "end_date_of_auth",
    ];

    for (const key of optionalKeys) {
      let value = finalParams[key];
      if (value === undefined || value === null || value === "") continue;

      if ((key === "start_date_of_auth" || key === "end_date_of_auth") && typeof value === "string") {
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
          const [mm, dd, yyyy] = value.split("/");
          const date = new Date(yyyy, mm - 1, dd);

          if (
            date.getFullYear() == yyyy &&
            date.getMonth() == mm - 1 &&
            date.getDate() == dd
          ) {
            value = `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
          } else {
            continue;
          }
        }

        if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) continue;
      }

      query[key] = value;
    }

    if (finalSort && finalSort.sort_by && finalSort.sort_field_name) {
      query.sort_by = finalSort.sort_by;
      query.sort_field_name = finalSort.sort_field_name;
    }

    const qs = Object.entries(query)
      .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
      .join("&");

    return HTTP.get(`${apiBaseUrl}file-list?${qs}`);
  },
  getClientFileData(id) {
    return HTTP.get(apiBaseUrl + `view-client-file/` + id);
  },

  updateClientFile(params) {
    return HTTP.post(apiBaseUrl + `update-client-file`, params);
  },

  deleteClientFile(params) {
    return HTTP.post(apiBaseUrl + `delete-client-file`, params);
  },

  downloadConvertedDocFile(id) {
    let url = apiBaseUrl + `converted-docx-file-download?download_id=` + id;

    return HTTP.post(url);
  },
  downloadConvertedExclFile(id) {
    let url = apiBaseUrl + `converted-xlsx-file-download?download_id=` + id;

    return HTTP.post(url);
  },
  getAllLoacationsForDropdown(search) {
    let url = apiBaseUrl + `all-locations?serach=` + search;
    return HTTP.get(url);
  },
  getAllServicesForDropdown() {
    let url = apiBaseUrl + `all-services`;
    return HTTP.get(url);
  },
  getAllStaffByBCBA(params) {
    let url = apiBaseUrl + `all-staff-new`;
    return HTTP.post(url, params);
  },
  getBillingScheduleList(params) {
    let url = apiBaseUrl + `billing-schedule?search=${params.search}&locations=${params.locations}&start_date=${params.start_date}&end_date=${params.end_date}&timeRange=${params.timeRange}&type=${params.type}&days=${params.days}&student=${params.student}&page=${params.page}&per_page=${params.per_page}&sort_by=${params.sort_by}&sort_field_name=${params.sort_field_name}&service_line=${params.service_line}&service=${params.service}&place_of_service=${params.place_of_service}`;
    return HTTP.get(url, params);
  },
  downloadBillingScheduleList(params) {
    let url = apiBaseUrl + `billing-schedule/export`;
    return HTTP.post(url, params);
  },
  getGroupScheduleList(params) {
    let url = apiBaseUrl + `group-schedule?search=${params.search}&locations=${params.locations}&start_date=${params.start_date}&end_date=${params.end_date}&timeRange=${params.timeRange}&type=${params.type}&days=${params.days}&students=${params.students}&recurrence_type=${params.reccurence_type}&page=${params.page}&per_page=${params.per_page}&sort_by=${params.sort_by}&sort_field_name=${params.sort_field_name}`;
    return HTTP.get(url, params);
  },
  getGroupScheduleInfo(id) {
    let url = apiBaseUrl + `group-schedule/${id}`
    return HTTP.get(url);
  },
  addGroupSchedule(params) {
    let url = apiBaseUrl + `group-schedule`
    return HTTP.post(url, params);
  },
  updateGroupSchedule(id, params) {
    let url = apiBaseUrl + `group-schedule/${id}`
    return HTTP.put(url, params);
  },
  deleteGroupSchedule(id) {
    let url = apiBaseUrl + `group-schedule/${id}`
    return HTTP.delete(url);
  },
  getStudentsGroupSchedule(id, search) {
    let url = apiBaseUrl + `group-schedule/get-students/${id}?search=${search}`
    return HTTP.get(url);
  },
  assignStudentToGroupSchedule(params) {
    let url = apiBaseUrl + `group-schedule/assign-students`
    return HTTP.post(url, params);
  },
  getWorkflowsDataList(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `workflow?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.per_page;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  addWorkflowData(params) {
    return HTTP.post(apiBaseUrl + `workflow`, params);
  },
  updateWorkflowData(id, params) {
    return HTTP.put(apiBaseUrl + `workflow/${id}`, params);
  },
  deleteWorkflowData(id) {
    return HTTP.delete(apiBaseUrl + `workflow/${id}`);
  },
  getWorkflowDetails(id) {
    let url = apiBaseUrl + `workflow/${id}`
    return HTTP.get(url);
  },
  getWorkflowsTaskList(id, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `workflow_task?workflow_id=${id}`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    // if(!_.isEmpty(sort)) {
    //   url = url+`&sort_by=`+sort.sort_by+`&sort_field_name=`+sort.sort_field_name;
    // }

    return HTTP.get(url);
  },
  addWorkflowTask(params) {
    return HTTP.post(apiBaseUrl + `workflow_task`, params);
  },
  updateWorkflowTask(id, params) {
    return HTTP.put(apiBaseUrl + `workflow_task/${id}`, params);
  },

  getWorkflowCalendarEventsList(id, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `workflow_calendar_event?workflow_id=${id}`;

    if (!_.isEmpty(params)) {
      url = url + `&page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }
    return HTTP.get(url);
  },
  getWorkflowCalendarEventDetails(eventId) {
    let url = apiBaseUrl + `workflow_calendar_event/${eventId}`;
    return HTTP.get(url);
  },
  addWorkflowCalendarEvent(params) {
    return HTTP.post(apiBaseUrl + `workflow_calendar_event`, params);
  },
  updateWorkflowCalendarEvent(eventId, params) {
    return HTTP.put(apiBaseUrl + `workflow_calendar_event/${eventId}`, params);
  },
  deleteWorkflowCalendarEvent(eventId) {
    return HTTP.delete(apiBaseUrl + `workflow_calendar_event/${eventId}`);
  },

  getWorkflowDocumentTemplateList(id, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `workflow_document_template?workflow_id=${id}`;

    if (!_.isEmpty(params)) {
      url = url + `&page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }
    return HTTP.get(url);
  },
  getWorkflowDocumentTemplateDetails(templateId) {
    let url = apiBaseUrl + `workflow_document_template/${templateId}`;
    return HTTP.get(url);
  },
  addWorkflowDocumentTemplate(params) {
    return HTTP.post(apiBaseUrl + `workflow_document_template`, params);
  },
  updateWorkflowDocumentTemplate(templateId, params) {
    return HTTP.put(apiBaseUrl + `workflow_document_template/${templateId}`, params);
  },
  deleteWorkflowDocumentTemplate(templateId) {
    return HTTP.delete(apiBaseUrl + `workflow_document_template/${templateId}`);
  },
  getAssignedWorkflows(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `assign-workflow`;

    if (!_.isEmpty(params)) {
      url += `?page=` + params.page + `&per_page=` + params.per_page;
    }

    if (!_.isEmpty(data)) {
      url += `&assigned_type=${data.assigned_type}&assigned_id=${data.assigned_id}`;
    }

    if (!_.isEmpty(sort)) {
      url += `&sort_by=${sort.sort_by}&sort_field_name=${sort.sort_field_name}`;
    }

    return HTTP.get(url);
  },
  getAssignedWorkflowDetails(id) {
    return HTTP.get(apiBaseUrl + `assign-workflow/${id}`);
  },
  assignWorkflow(params) {
    return HTTP.post(apiBaseUrl + `assign-workflow`, params);
  },
  updateAssignedWorkflow(id, params) {
    return HTTP.put(apiBaseUrl + `assign-workflow/${id}`, params);
  },
  deleteAssignedWorkflow(id) {
    return HTTP.delete(apiBaseUrl + `assign-workflow/${id}`);
  },

  // assigned workflows to case-document apis

  getAssignedWorkflowEvents(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `assign-workflow-event`;
    if (!_.isEmpty(params)) {
      url += `?page=` + params.page + `&per_page=` + params.per_page;
    }

    if (!_.isEmpty(data)) {
      url += `&assignworkflow_id=` + data.assignworkflow_id;
    }

    if (!_.isEmpty(sort)) {
      url += `&sort_by=${sort.sort_by}&sort_field_name=${sort.sort_field_name}`;
    }

    return HTTP.get(url);
  },
  getAssignedWorkflowEventDetails(id) {
    let url = apiBaseUrl + `assign-workflow-event/${id}`;
    return HTTP.get(url);
  },
  updateAssignedWorkflowEventWorkflowDetails(id, params) {
    let url = apiBaseUrl + `assign-workflow-event/${id}`;
    return HTTP.put(url, params);
  },
  deleteAssignedWorkflowEvent(id) {
    return HTTP.delete(apiBaseUrl + `assign-workflow-event/${id}`);
  },
  getEventColorCode() {
    return HTTP.get(apiBaseUrl + `session-type-colors`);
  },
  /*Import File Log Start*/
  getImportCHecklist(import_area) {
    return HTTP.get(apiBaseUrl + `import-checklist/get-area?area_name=${import_area}`);
  },
  getImportLogList(params, data = {}, sort = {}) {

    let url = apiBaseUrl + `import-checklist/log?page=` + params.page + `&per_page=` + params.perPage;

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search + `&start_date=` + data.date_from + `&end_date=` + data.date_to;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getImportLogDetailsList(source_id, params, data = {}, sort = {}) {

    let url = apiBaseUrl + `import-checklist/log/${source_id}`;

    // if(!_.isEmpty(data)) {
    //   url = url+`&search=`+data.search+`&start_date=`+data.date_from+`&end_date=`+data.date_to;
    // }

    // if(!_.isEmpty(sort)) {
    //   url = url+`&sort_by=`+sort.sort_by+`&sort_field_name=`+sort.sort_field_name;
    // }

    return HTTP.get(url);
  },
  downloadLogFile(params) {
    return HTTP.post(apiBaseUrl + `import-checklist/export-log`, params);
  },

  getAllTemplateCode() {
    return HTTP.get(apiBaseUrl + `get-all-template-code`);
  },

  getTypeHeaderList() {
    return HTTP.get(apiBaseUrl + `goal-header-type-list`);
  },

  // Group Apis
  getGroupList(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `groups?`;
    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
    // return HTTP.get(apiBaseUrl+`groups?search=`+params.search);
  },

  getAllGroupsFofDropDown(search = '') {
    let url = apiBaseUrl + `all-groups`;
    if (search != '') {
      url = url + '?search=' + search;
    }
    return HTTP.get(url);
  },

  getGroupDetails(id) {
    return HTTP.get(apiBaseUrl + `groups/` + id);
  },

  createGroup(params) {
    return HTTP.post(apiBaseUrl + `groups`, params);
  },

  updateGroup(group_id, params) {
    return HTTP.put(apiBaseUrl + `groups/` + group_id, params);
  },

  deleteGroup(params) {
    return HTTP.delete(apiBaseUrl + `groups/` + params);
  },

  // Classes
  getClassList(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `classes?`;
    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
    // return HTTP.get(apiBaseUrl+`groups?search=`+params.search);
  },

  getAllClassesFofDropDown(search) {
    let url = apiBaseUrl + `all-classes`;
    if (search != '') {
      url = url + '?search=' + search;
    }
    return HTTP.get(url);
  },

  getClassDetails(id) {
    return HTTP.get(apiBaseUrl + `classes/` + id);
  },
  createClass(params) {
    return HTTP.post(apiBaseUrl + `classes`, params);
  },

  updateClass(class_id, params) {
    return HTTP.put(apiBaseUrl + `classes/` + class_id, params);
  },

  deleteClass(params) {
    return HTTP.delete(apiBaseUrl + `classes/` + params);
  },


  getListTemplateList(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `goal-header-list?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },

  saveGoalTempalteData(params) {
    return HTTP.post(apiBaseUrl + `goal-header-add`, params)
  },

  saveGoalTemplateDataV2(params) {
    return HTTP.post(apiBaseUrl + `goal-header-add-v2`, params)
  },

  deleteGoalTemplateData(params) {
    return HTTP.post(apiBaseUrl + `goal-header-delete`, params)
  },

  getConversionTemplateDetails(id) {
    let url = apiBaseUrl + `goal-header-show/${id}`
    return HTTP.get(url);
  },

  updateGoalTempalteData(id, params) {
    return HTTP.post(apiBaseUrl + `goal-header-update/${id}`, params)
  },

  updateGoalTempalteDataV2(id, params) {
    return HTTP.post(apiBaseUrl + `goal-header-update-v2/${id}`, params)
  },

  getGoalHeaderTemplateList(params, search) {
    let url = apiBaseUrl + `goal-header-list?search=${search}&per_page=${params.per_page}&page=${params.page}`;
    return HTTP.get(url);
  },
  getInvoiceReports(params, data = {}, sort = {}) {

    let url = apiBaseUrl + `invoice-report?page=` + params.page + `&per_page=` + params.perPage;

    if (!_.isEmpty(data)) {
      url = url + `&student_id=` + data.student_id + `&month_year=` + data.month_year + `&serviceId=` + data.serviceId + `&staffId=` + data.staffId;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },

  getInvoiceReportDropdown() {

    let url = apiBaseUrl + `invoice-report-dropdown-filter`;

    return HTTP.get(url);
  },

  sessionTemplateCategoryImport(params) {

    return HTTP.post(apiBaseUrl + `session-template-category-import`, params)
  },

  sessionTemplateCategoryExport(params) {
    return HTTP.post(apiBaseUrl + `session-template-category-export`, params)
  },

  studentStaffImport(params) {
    return HTTP.post(apiBaseUrl + `import-student-staff-school`, params)
  },

  mergeFieldExport(params) {
    return HTTP.post(apiBaseUrl + `merge-field-export`, params)
  },

  mergeFieldImport(params) {
    return HTTP.post(apiBaseUrl + `merge-field-import`, params)
  },

  getFilesByUserGroup() {
    return HTTP.get(apiBaseUrl + `staff-file-type`)
  },

  getFileLabelsByGroupId(id) {
    return HTTP.get(apiBaseUrl + `staff-file-type/` + id)
  },

  addFileLabelsToGroups(params) {
    return HTTP.post(apiBaseUrl + `staff-file-type`, params)
  },

  updateFileLabelsToGroups(id, params) {
    return HTTP.put(apiBaseUrl + `staff-file-type/` + id, params)
  },

  getUserGroupLabelsForDropdown(params) {
    // console.log(params);
    return HTTP.post(apiBaseUrl + `staff-file-get-unique-lebels`, params)
  },

  saveUserDocSingleGroupAndLabels(params) {
    return HTTP.post(apiBaseUrl + `staff-file-save-pdf-individual`, params)
  },

  saveUserDocSingleFormData(params) {
    return HTTP.post(apiBaseUrl + `staff-file-save-pdf-data-individual`, params)
  },

  saveUserDocBulkGroupAndLabels(params) {
    return HTTP.post(apiBaseUrl + `staff-file-save-pdf-bulk`, params)
  },

  saveUserDocBulkFormData(params) {
    return HTTP.post(apiBaseUrl + `staff-file-save-pdf-data-bulk`, params)
  },

  importFileUserDocLabels(params) {
    return HTTP.post(apiBaseUrl + `staff-file-type-import`, params)
  },

  exportFileUserDocLabels() {
    return HTTP.get(apiBaseUrl + `staff-file-type-export`);
  },

  saveStaffDocumentFormFields(params) {
    return HTTP.post(apiBaseUrl + `store-staff-file-pdf-data`, params)
  },

  getStaffDocumentFormFields(id) {
    return HTTP.get(apiBaseUrl + `show-staff-file-pdf-data/` + id);
  },

  getGeneratedPdf(student_id) {
    return HTTP.get(apiBaseUrl + `session-form-template-report-events?studentId=` + student_id);
  },

  createMedicalRecord(data = {}) {
    return HTTP.post(apiBaseUrl + `medical-records`, data)
  },

  getErrorList(auth_name, operation_name, issueName) {
    return HTTP.get(apiBaseUrl + `error-descriptions?pageLink=` + auth_name + `&operationName=` + operation_name + `&issueName=` + issueName);
  },

  exportErrorList(params) {
    return HTTP.post(apiBaseUrl + `error-descriptions-export`, params)
  },

  getFunderList(params) {
    return HTTP.post(apiBaseUrl + `get-session-authorization`, params)
  },

  sessionReportMerge(params) {
    return HTTP.post(apiBaseUrl + `session-report-pdf-merge`, params)
  },

  templateShortCodeList() {
    return HTTP.get(apiBaseUrl + `template-shortcode-list`)
  },

  getConversionTemplateList(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `goal-header-list-v2?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.per_page;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },

  addGoalHeaderV3(params) {
    return HTTP.post(apiBaseUrl + `goal-header-add-v3`, params)
  },

  showGoalHeaderV3(id) {
    return HTTP.get(apiBaseUrl + `goal-header-show-v2/` + id)
  },

  updateGoalHeaderV3(id, params) {
    return HTTP.post(apiBaseUrl + `goal-header-update-v3/` + id, params)
  },
  restartCronJob(id) {
    // return HTTP.post(apiBaseUrl+``, params);
    return HTTP.post(apiBaseUrl + `restart-cron/` + id);
  },
  getRethinkSessionData(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `rethink-session-data?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&status=` + data.status + `&date_from=` + data.date_from + `&date_to=` + data.date_to + `&serviceLines=` + data.serviceLines + `&service=` + data.service + `&studentName=` + data.studentName;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getModuleAndMenuList(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `label-list?`;

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getModuleMenuByLabel(module, params, data = {}, sort = {}) {
    let url = apiBaseUrl + `permission-list?label=` + module;

    if (!_.isEmpty(params)) {
      url = url + `&page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
  },
  getModuleMethods(params) {
    return HTTP.post(apiBaseUrl + `permission-method`, params);
  },
  saveModulePermissions(params) {
    return HTTP.post(apiBaseUrl + `permission-management`, params);
  },
  updateModulePermissions(params) {
    return HTTP.put(apiBaseUrl + `permission-management/` + params.updateId, params);
  },
  checkNameAvailability(params) {
    return HTTP.post(apiBaseUrl + `permission-management/nameCheck`, params);
  },
  getSessionFromTemplateCheck(data = {}) {
    return HTTP.post(apiBaseUrl + `session-form-template-shortcode-check`, data)
  },
  getRethinkDataMonitoring(params, data = {}, sort = {}) {
    let url = apiBaseUrl + `rethink-importer?`;
    // console.log(params);

    if (!_.isEmpty(params)) {
      url = url + `page=` + params.page + `&per_page=` + params.perPage;
    }

    if (!_.isEmpty(data)) {
      url = url + `&search=` + data.search;
    }

    if (!_.isEmpty(sort)) {
      url = url + `&sort_by=` + sort.sort_by + `&sort_field_name=` + sort.sort_field_name;
    }

    return HTTP.get(url);
    // return HTTP.get(apiBaseUrl + `get-files-folders`);
  },
  /* Sample Files */
  getAllSampleFiles() {
    let url = apiBaseUrl + `sample-file`;
    // if(!_.isEmpty(params)) {
    //   url = url+`?page=`+params.page+`&per_page=`+params.per_page;
    // }

    // if(!_.isEmpty(data)) {
    //   url = url+`&search=`+data.search;
    // }

    // if(!_.isEmpty(sort)) {
    //   url = url+`&sort_by=`+sort.sort_by+`&sort_field_name=`+sort.sort_field_name;
    // }
    return HTTP.get(url);
  },
  getSampleFile(type) {
    let url = apiBaseUrl + `sample-file/${type}`;
    return HTTP.get(url);
  },
  uploadSampleFile(params) {
    return HTTP.post(apiBaseUrl + `sample-file`, params);
  },
  updateSampleFile(params, handle) {
    return HTTP.post(apiBaseUrl + `sample-file/${handle}`, params);
  },
  deleteSampleFile(handle) {
    return HTTP.delete(apiBaseUrl + `sample-file/` + handle);
  },
  getSampleFileTypeList() {
    let url = apiBaseUrl + `get-sample-file-type-list`;
    return HTTP.get(url);
  },
  getSampleFileByType(type) {
    let url = apiBaseUrl + `sample-file?type=${type}`;
    return HTTP.get(url);
  },
  getSampleFileDownloadUrl(id) {
    let url = apiBaseUrl + `get-sample-file-download-url?id=${id}`;
    return HTTP.get(url);
  },
  downloadSampleFile(url) {
    return HTTP.get(url);
  },
  /*
    |-----------------------------------------------
    | Help desk
    |-----------------------------------------------
   */
  sendFeedback(formData) {
    return axios({
      url: apiBaseUrl + 'help-desk/store',
      method: "POST",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    })
  },
  /*
    |-----------------------------------------------
    | Excel importing
    |-----------------------------------------------
   */
  createImport: (formData) => HTTP.post(`${apiBaseUrl}excel-import-logs`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  }),
  updateImport: (uuid, chosenSheet) => HTTP.put(`${apiBaseUrl}excel-import-logs/${uuid}`, { chosen_sheet: chosenSheet }),

  /*
  * Contracts
  * Standard REST endpoints:
  * - GET    api/contracts
  * - GET    api/contracts/:id
  * - POST   api/contracts
  * - PUT    api/contracts/:id
  * - DELETE api/contracts/:id
  */
  getContracts(params = {}, data = {}, sort = {}) {
    let url = apiBaseUrl + `contracts?`;

    // Pagination
    const page = params.page;
    const perPage = params.per_page ?? params.perPage;
    if (page != null && perPage != null) {
      url += `page=${page}&per_page=${perPage}`;
    }

    // Filters
    if (!_.isEmpty(data)) {
      if (data.search != null && data.search !== '') {
        url += `${url.endsWith('?') ? '' : '&'}search=${encodeURIComponent(data.search)}`;
      }
    }

    // Sorting
    if (!_.isEmpty(sort)) {
      if (sort.sort_by != null && sort.sort_by !== '') {
        url += `${url.endsWith('?') ? '' : '&'}sort_by=${encodeURIComponent(sort.sort_by)}`;
      }
      if (sort.sort_field_name != null && sort.sort_field_name !== '') {
        url += `&sort_field_name=${encodeURIComponent(sort.sort_field_name)}`;
      }
    }

    // Clean trailing '?' (if no query params were appended)
    if (url.endsWith('?')) url = url.slice(0, -1);

    return HTTP.get(url);
  },
  getContractDetails(id) {
    return HTTP.get(apiBaseUrl + `contracts/` + id);
  },
  createContractMultipart(formData) {
    return HTTP.post(apiBaseUrl + `contracts`, formData);
  },
  updateContractMultipart(id, payload = {}) {
    // Backend expects x-www-form-urlencoded on update.
    // Supports payload as:
    // - URLSearchParams
    // - string (already urlencoded)
    // - plain object
    const url = apiBaseUrl + `contracts/` + id;

    let body = payload;

    // Convert plain object to URLSearchParams (supports array values)
    if (payload && typeof payload === 'object' && !(payload instanceof URLSearchParams)) {
      const params = new URLSearchParams();
      Object.keys(payload).forEach((key) => {
        const value = payload[key];
        if (value === undefined || value === null) return;

        if (Array.isArray(value)) {
          const arrayKey = key.endsWith('[]') ? key : `${key}[]`;
          value.forEach((v) => {
            if (v === undefined || v === null) return;
            params.append(arrayKey, v);
          });
          return;
        }

        params.append(key, value);
      });
      body = params;
    }

    return HTTP.put(url, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
  },
  deleteContract(id) {
    return HTTP.delete(apiBaseUrl + `contracts/` + id);
  }
}
